<app-menu></app-menu>

<section class="controldp-page" *ngIf="tenantId; else noAccess">
  <div class="page-guide">CONTROLPS / CONTROLDP</div>

  <div class="tab-toolbar">
    <div class="cp-tabs dp-main-tabs">
      <button mat-stroked-button type="button" [class.active]="activeTab === 'dashboard'" (click)="setActiveTab('dashboard')">
        <mat-icon>dashboard</mat-icon>
        <span>Dashboard</span>
      </button>
      <button mat-stroked-button type="button" [class.active]="activeTab === 'collaborators'" (click)="setActiveTab('collaborators')">
        <mat-icon>groups</mat-icon>
        <span>Colaboradores</span>
      </button>
      <button mat-stroked-button type="button" *ngIf="isMaster" [class.active]="activeTab === 'digitalAdmissions'" (click)="setActiveTab('digitalAdmissions')">
        <mat-icon>badge</mat-icon>
        <span>Admissão digital</span>
      </button>
      <button mat-stroked-button type="button" *ngIf="isAdmin" [class.active]="activeTab === 'imports'" (click)="setActiveTab('imports')">
        <mat-icon>upload_file</mat-icon>
        <span>Importações</span>
      </button>
    </div>

    <div class="tab-toolbar__actions">
      <button
        mat-raised-button
        color="primary"
        class="quick-actions-btn"
        type="button"
        [matMenuTriggerFor]="novoMenu"
        #novoMenuTrigger="matMenuTrigger">
        <mat-icon>add</mat-icon>
        <span class="quick-actions-btn__label">Novo</span>
        <mat-icon>expand_more</mat-icon>
      </button>
      <button class="filter-icon-button" type="button" (click)="openFilterModal()" aria-label="Filtrar">
        <mat-icon>filter_list</mat-icon>
      </button>
      <button
        class="btn ghost"
        type="button"
        *ngIf="filterSectorId || filterDepartmentId || dashboardFilter !== 'ALL' || feedbackDashboardTemplateId"
        (click)="clearFilters()">
        Limpar filtro
      </button>
      <mat-menu
        #novoMenu="matMenu"
        class="novo-menu-panel"
        xPosition="before"
        yPosition="below"
        [hasBackdrop]="true"
        backdropClass="cdk-overlay-transparent-backdrop">
        <button mat-menu-item type="button" *ngIf="isMaster" (click)="openDigitalAdmissionModal()">
          Nova admissão
        </button>
        <button mat-menu-item type="button" (click)="openEmployeeModal()">
          Novo colaborador(a)
        </button>
        <button mat-menu-item type="button" (click)="openFeedbackModal()">
          Novo feedback
        </button>
        <button mat-menu-item type="button" (click)="openRoleModal()">
          Novo cargo
        </button>
        <button mat-menu-item type="button" *ngIf="isMaster" (click)="openAlertModal()">
          Novo alerta
        </button>
      </mat-menu>
    </div>
  </div>

  <ng-container *ngIf="activeTab === 'dashboard'">
    <ng-container *ngIf="showDashboardCollaborator">
      <section class="dashboard-v2-kpis">
        <article class="dashboard-v2-kpi-card">
          <div class="dashboard-v2-kpi-card__head">
            <span>Total de colaboradores</span>
            <mat-icon>groups</mat-icon>
          </div>
          <strong>{{ dashboardView.total }}</strong>
          <small>Base filtrada atual</small>
        </article>

        <article class="dashboard-v2-kpi-card">
          <div class="dashboard-v2-kpi-card__head">
            <span>Ativos</span>
            <mat-icon>verified_user</mat-icon>
          </div>
          <strong>{{ dashboardView.active }}</strong>
          <small class="positive">+{{ hiresLast30Days }} admissões nos últimos 30 dias</small>
        </article>

        <article class="dashboard-v2-kpi-card">
          <div class="dashboard-v2-kpi-card__head">
            <span>Taxa de atividade</span>
            <mat-icon>donut_large</mat-icon>
          </div>
          <strong>{{ activeRateLabel }}</strong>
          <small>{{ dashboardInactiveRateLabel }} inativos na base</small>
        </article>
      </section>

      <section class="dashboard-v2-layout">
        <article class="card dashboard-v2-card dashboard-v2-card--line">
          <header class="dashboard-v2-card__head">
            <h3>Análise de admissões (últimos {{ dashboardPeriodMonths }} meses)</h3>
            <div class="dashboard-v2-period-toggle">
              <button
                type="button"
                class="dashboard-v2-period-btn"
                *ngFor="let option of dashboardPeriodOptions"
                [class.active]="dashboardPeriodMonths === option"
                (click)="setDashboardPeriod(option)">
                {{ option }}m
              </button>
            </div>
          </header>

          <div class="dashboard-v2-line-chart" *ngIf="admissionsByMonth.length">
            <canvas
              baseChart
              [type]="'line'"
              [data]="admissionsLineChartData"
              [options]="dashboardLineChartOptions">
            </canvas>
          </div>

          <div class="dashboard-v2-legend">
            <span title="Quantidade real de contratações em cada mês do período."><i class="legend-dot legend-dot--primary"></i>Admissões</span>
            <span title="Linha suavizada por média móvel de 3 meses para mostrar direção geral (queda/subida)."><i class="legend-dot legend-dot--secondary"></i>Tendência</span>
            <span title="Média simples de contratações por mês no período selecionado."><i class="legend-line legend-line--average"></i>Média {{ admissionsAveragePerMonthLabel }}/mês</span>
          </div>
        </article>

        <article class="card dashboard-v2-card dashboard-v2-card--department">
          <header class="dashboard-v2-card__head">
            <h3>Distribuição por departamento</h3>
            <span>Departamentos</span>
          </header>

          <div class="dashboard-v2-donut-wrap">
            <div class="dashboard-v2-donut" [style.background]="dashboardDepartmentDonutStyle">
              <div class="dashboard-v2-donut__inner">
                <strong>{{ dashboardDepartmentTop.count }}</strong>
                <small>{{ dashboardDepartmentTop.label }}</small>
              </div>
            </div>
            <div class="dashboard-v2-status-bars">
              <ng-container *ngFor="let row of dashboardDepartmentRows">
                <div>
                  <span>{{ row.label }}</span>
                  <strong>{{ row.count }} · {{ row.percent }}%</strong>
                </div>
                <div class="mini-bar">
                  <div class="mini-bar__fill" [style.width.%]="row.percent" [style.background]="row.color"></div>
                </div>
              </ng-container>
              <div class="empty" *ngIf="!dashboardDepartmentRows.length">
                Sem dados de departamento para o filtro atual.
              </div>
            </div>
          </div>
        </article>

        <article class="card dashboard-v2-card dashboard-v2-card--quarter">
          <header class="dashboard-v2-card__head">
            <h3>Admissões e desligados (trimestral)</h3>
            <span>Últimos 6 trimestres</span>
          </header>
          <div class="dashboard-v2-quarter-chart">
            <div class="dashboard-v2-quarter-group" *ngFor="let quarter of admissionsQuarterlySeries">
              <div class="dashboard-v2-quarter-bars">
                <span
                  class="bar-vertical bar-vertical--admissions"
                  [style.height.%]="getBarPercent(quarter.admissions, admissionsQuarterlyMax)">
                </span>
                <span
                  class="bar-vertical bar-vertical--inactive"
                  [style.height.%]="getBarPercent(quarter.inactive, admissionsQuarterlyMax)">
                </span>
              </div>
              <small>{{ quarter.label }}</small>
            </div>
          </div>
          <div class="dashboard-v2-legend">
            <span><i class="legend-dot legend-dot--primary"></i>Admissões</span>
            <span><i class="legend-dot legend-dot--inactive"></i>Desligados (base)</span>
          </div>
        </article>

        <article class="card dashboard-v2-card dashboard-v2-card--gender">
          <header class="dashboard-v2-card__head">
            <h3>Diversidade por gênero</h3>
            <span>Donut por gênero</span>
          </header>
          <div class="dashboard-v2-demographic">
            <div class="dashboard-v2-donut dashboard-v2-donut--small" [style.background]="dashboardGenderDonutStyle">
              <div class="dashboard-v2-donut__inner">
                <strong>{{ scopedEmployees.length }}</strong>
                <small>colaboradores</small>
              </div>
            </div>
            <div class="dashboard-v2-demographic-list">
              <div class="dashboard-v2-demographic-row" *ngFor="let row of dashboardGenderRows">
                <span><i [style.background]="row.color"></i>{{ row.label }}</span>
                <strong>{{ row.count }} · {{ row.percent }}%</strong>
              </div>
              <div class="empty" *ngIf="!dashboardGenderRows.length">Sem dados de gênero.</div>
            </div>
          </div>
        </article>

        <article class="card dashboard-v2-card dashboard-v2-card--age">
          <header class="dashboard-v2-card__head">
            <h3>Faixa etária da empresa</h3>
            <span>Distribuição por idade</span>
          </header>
          <div class="dashboard-v2-reasons">
            <div class="dashboard-v2-reason-row" *ngFor="let row of dashboardAgeRangeRows">
              <div class="dashboard-v2-reason-row__top">
                <span>{{ row.label }}</span>
                <strong>{{ row.count }}</strong>
              </div>
              <div class="mini-bar">
                <div
                  class="mini-bar__fill mini-bar__fill--primary"
                  [style.width.%]="getBarPercent(row.count, dashboardAgeRangeMax)">
                </div>
              </div>
            </div>
          </div>
        </article>

        <article class="card dashboard-v2-card dashboard-v2-card--leave">
          <header class="dashboard-v2-card__head">
            <h3>Motivos de afastamento</h3>
            <div class="dashboard-v2-period-toggle">
              <button
                type="button"
                class="dashboard-v2-period-btn"
                *ngFor="let option of dashboardLeavePeriodOptions"
                [class.active]="dashboardLeavePeriodMonths === option"
                (click)="setDashboardLeavePeriod(option)">
                {{ option }}m
              </button>
            </div>
          </header>
          <div class="dashboard-v2-reasons">
            <div class="dashboard-v2-reason-row" *ngFor="let reason of dashboardLeaveReasonRows">
              <div class="dashboard-v2-reason-row__top">
                <span>{{ reason.label }}</span>
                <strong>{{ reason.count }}</strong>
              </div>
              <div class="mini-bar">
                <div
                  class="mini-bar__fill mini-bar__fill--primary"
                  [style.width.%]="getBarPercent(reason.count, dashboardLeaveReasonMax)">
                </div>
              </div>
            </div>
            <div class="empty" *ngIf="!dashboardLeaveReasonRows.length">
              Nenhum afastamento registrado no período selecionado.
            </div>
          </div>
        </article>

        <article class="card dashboard-v2-card dashboard-v2-card--birthdays">
          <header class="dashboard-v2-card__head">
            <h3>Aniversariantes do mês</h3>
            <span>{{ dashboardBirthdaysThisMonth.length }} encontrado(s)</span>
          </header>
          <div class="dashboard-v2-birthdays">
            <div class="dashboard-v2-birthday-item" *ngFor="let person of dashboardBirthdaysThisMonth">
              <span class="avatar">{{ person.initials }}</span>
              <div>
                <strong>{{ person.full_name }}</strong>
                <small>{{ person.birth_day }}/{{ person.birth_month }} · {{ person.age_label }}</small>
              </div>
            </div>
            <div class="empty" *ngIf="!dashboardBirthdaysThisMonth.length">
              Nenhum aniversariante neste mês para o filtro atual.
            </div>
          </div>
        </article>
      </section>
    </ng-container>

    <section class="dashboard-v2-layout" *ngIf="showDashboardThermometer">
      <article class="card dashboard-v2-card dashboard-v2-card--mood">
        <header class="dashboard-v2-card__head">
          <h3>Termômetro de humor dos colaboradores</h3>
          <span>Base do escopo ControlDP</span>
        </header>
        <div class="dashboard-v2-mood-chart" *ngIf="!moodSummaryLoading; else moodLoading">
          <div class="dashboard-v2-mood-summary">
            <span>Total colaboradores no escopo: <strong>{{ scopedMoodEmployeeTotal }}</strong></span>
            <span>Responderam no período: <strong>{{ moodUniqueRespondents }}</strong></span>
            <span>Taxa de resposta: <strong>{{ moodResponseRateLabel }}</strong></span>
          </div>
          <div class="dashboard-v2-mood-grid">
            <div class="dashboard-v2-mood-donut-wrap">
              <div class="dashboard-v2-mood-donut" [style.background]="moodDonutStyle">
                <div class="dashboard-v2-mood-donut__inner">
                  <strong>{{ moodSummaryTotal }}</strong>
                  <small>Respostas</small>
                </div>
              </div>
            </div>
            <div class="dashboard-v2-mood-rows">
              <div class="dashboard-v2-mood-row" *ngFor="let row of moodSummaryRows">
                <span class="mood-label">{{ row.emoji }} {{ row.label }}</span>
                <div class="mini-bar">
                  <div class="mini-bar__fill mini-bar__fill--primary" [style.width.%]="row.percent" [style.background]="moodColor(row.id)"></div>
                </div>
                <strong>{{ row.percent | number:'1.0-0' }}% · {{ row.count }}</strong>
              </div>
            </div>
          </div>
          <div class="empty" *ngIf="!moodSummaryTotal">Sem respostas de humor no período.</div>
        </div>
        <ng-template #moodLoading>
          <div class="loading">Carregando termômetro de humor...</div>
        </ng-template>
      </article>

      <article class="card dashboard-v2-card dashboard-v2-card--mood-trend">
        <header class="dashboard-v2-card__head">
          <h3>Quantidade de respostas do termômetro</h3>
          <div class="dashboard-v2-period-toggle">
            <button
              type="button"
              class="dashboard-v2-period-btn"
              *ngFor="let option of moodPeriodOptions"
              [class.active]="moodPeriodMonths === option"
              (click)="setMoodPeriod(option)">
              {{ option }}m
            </button>
          </div>
        </header>
        <div class="dashboard-v2-line-chart dashboard-v2-line-chart--mood" *ngIf="!moodSummaryLoading">
          <canvas
            baseChart
            [type]="'line'"
            [data]="moodTrendLineChartData"
            [options]="dashboardLineChartOptions">
          </canvas>
        </div>
        <div class="dashboard-v2-legend">
          <span><i class="legend-dot legend-dot--primary"></i>Respostas</span>
          <span><i class="legend-dot legend-dot--secondary"></i>Colaboradores que responderam</span>
        </div>
        <div class="loading" *ngIf="moodSummaryLoading">Carregando termômetro de humor...</div>
        <div class="empty" *ngIf="!moodSummaryLoading && !moodMonthlyRows.length">Sem respostas no período selecionado.</div>
      </article>

      <article class="card dashboard-v2-card dashboard-v2-card--mood-gender">
        <header class="dashboard-v2-card__head">
          <h3>Respostas por gênero</h3>
          <span>{{ moodPeriodMonths }}m</span>
        </header>
        <div class="dashboard-v2-mood-gender" *ngIf="!moodSummaryLoading">
          <div class="dashboard-v2-mood-gender-donut" [style.background]="moodGenderDonutStyle">
            <div class="dashboard-v2-mood-gender-donut__inner">
              <strong>{{ moodSummaryTotal }}</strong>
              <small>Total</small>
            </div>
          </div>
          <div class="chart-list compact">
            <div class="chart-row" *ngFor="let item of moodGenderRows">
              <span class="mood-gender-label">
                <i class="mood-gender-dot" [style.background]="moodGenderColor(item.key)"></i>
                {{ item.label }}
              </span>
              <div class="bar">
                <div class="bar-fill" [style.width.%]="getBarPercent(item.count, moodGenderMax)" [style.background]="moodGenderColor(item.key)"></div>
              </div>
              <strong>{{ item.count }} · {{ item.percent }}%</strong>
            </div>
          </div>
        </div>
        <div class="loading" *ngIf="moodSummaryLoading">Carregando termômetro de humor...</div>
        <div class="empty" *ngIf="!moodSummaryLoading && !moodGenderRows.length">Sem dados por gênero no período.</div>
      </article>

      <article class="card dashboard-v2-card dashboard-v2-card--mood-department">
        <header class="dashboard-v2-card__head">
          <h3>Respostas por departamento</h3>
          <span>{{ moodPeriodMonths }}m</span>
        </header>
        <div class="chart-list scrollable compact" *ngIf="!moodSummaryLoading">
          <div class="chart-row" *ngFor="let item of moodDepartmentRows">
            <span>{{ item.label }}</span>
            <div class="bar bar--stacked">
              <div class="bar-fill bar-fill--positive" [style.width.%]="getDepartmentMoodSegmentPercent(item, 'positive')"></div>
              <div class="bar-fill bar-fill--neutral" [style.width.%]="getDepartmentMoodSegmentPercent(item, 'neutral')"></div>
              <div class="bar-fill bar-fill--negative" [style.width.%]="getDepartmentMoodSegmentPercent(item, 'negative')"></div>
            </div>
            <strong>{{ item.count }} · {{ item.percent }}%</strong>
          </div>
          <div class="dashboard-v2-legend">
            <span><i class="legend-dot legend-dot--positive"></i>Excelente + Bom</span>
            <span><i class="legend-dot legend-dot--neutral"></i>Neutro</span>
            <span><i class="legend-dot legend-dot--negative"></i>Triste + Péssimo</span>
          </div>
          <div class="empty" *ngIf="!moodDepartmentRows.length">Sem dados por departamento no período.</div>
        </div>
        <div class="loading" *ngIf="moodSummaryLoading">Carregando termômetro de humor...</div>
      </article>
    </section>

    <ng-container *ngIf="showDashboardFeedback">
      <section class="dashboard-v2-kpis">
        <article class="dashboard-v2-kpi-card">
          <div class="dashboard-v2-kpi-card__head">
            <span>Feedbacks registrados</span>
            <mat-icon>fact_check</mat-icon>
          </div>
          <strong>{{ feedbackDashboardSummary.total }}</strong>
          <small>{{ feedbackDashboardSummary.unique_employees }} colaborador(es) avaliados</small>
        </article>

        <article class="dashboard-v2-kpi-card">
          <div class="dashboard-v2-kpi-card__head">
            <span>Feedbacks aplicados</span>
            <mat-icon>task_alt</mat-icon>
          </div>
          <strong>{{ feedbackDashboardSummary.applied }}</strong>
          <small class="positive">Rascunhos: {{ feedbackDashboardSummary.draft }} · Agendados: {{ feedbackDashboardSummary.scheduled }}</small>
        </article>

        <article class="dashboard-v2-kpi-card">
          <div class="dashboard-v2-kpi-card__head">
            <span>Taxa de aplicação</span>
            <mat-icon>query_stats</mat-icon>
          </div>
          <strong>{{ feedbackAppliedRateLabel }}</strong>
          <small>Última aplicação: {{ feedbackDashboardSummary.last_applied_at ? (feedbackDashboardSummary.last_applied_at | date:'short') : 'sem registros' }}</small>
        </article>
      </section>

      <div class="loading" *ngIf="feedbackDashboardLoading">Carregando indicadores de feedback...</div>
      <div class="feedback-inline-error" *ngIf="feedbackDashboardError">{{ feedbackDashboardError }}</div>

      <section class="dashboard-v2-layout" *ngIf="!feedbackDashboardLoading">
        <article class="card dashboard-v2-card dashboard-v2-card--feedback-line">
          <header class="dashboard-v2-card__head">
            <h3>Evolução de feedbacks (últimos {{ feedbackDashboardPeriodMonths }} meses)</h3>
            <div class="dashboard-v2-period-toggle">
              <button
                type="button"
                class="dashboard-v2-period-btn"
                *ngFor="let option of dashboardPeriodOptions"
                [class.active]="feedbackDashboardPeriodMonths === option"
                (click)="setFeedbackDashboardPeriod(option)">
                {{ option }}m
              </button>
            </div>
          </header>
          <div class="dashboard-v2-line-chart" *ngIf="feedbackMonthlyRows.length">
            <canvas
              baseChart
              [type]="'line'"
              [data]="feedbackLineChartData"
              [options]="dashboardLineChartOptions">
            </canvas>
          </div>
          <div class="dashboard-v2-legend">
            <span><i class="legend-dot legend-dot--primary"></i>Feedbacks aplicados</span>
            <span><i class="legend-dot legend-dot--secondary"></i>Tendência</span>
            <span><i class="legend-line legend-line--average"></i>Média {{ feedbackAveragePerMonthLabel }}/mês</span>
          </div>
        </article>

        <article class="card dashboard-v2-card dashboard-v2-card--feedback-template">
          <header class="dashboard-v2-card__head">
            <h3>Templates de feedback</h3>
            <span>{{ feedbackTemplateRows.length }} template(s)</span>
          </header>
          <div class="dashboard-v2-reasons">
            <div class="dashboard-v2-reason-row" *ngFor="let row of feedbackTemplateRows">
              <div class="dashboard-v2-reason-row__top">
                <span>{{ row.title }}</span>
                <strong>{{ row.total }} · {{ row.applied_rate | number:'1.0-1' }}%</strong>
              </div>
              <div class="mini-bar">
                <div class="mini-bar__fill mini-bar__fill--primary" [style.width.%]="getBarPercent(row.total, feedbackTemplateMax)"></div>
              </div>
            </div>
            <div class="empty" *ngIf="!feedbackTemplateRows.length">Nenhum template de feedback cadastrado.</div>
          </div>
        </article>

        <article class="card dashboard-v2-card dashboard-v2-card--feedback-status">
          <header class="dashboard-v2-card__head">
            <h3>Status dos feedbacks</h3>
            <span>Distribuição geral</span>
          </header>
          <div class="dashboard-v2-demographic">
            <div class="dashboard-v2-donut dashboard-v2-donut--small" [style.background]="feedbackStatusDonutStyle">
              <div class="dashboard-v2-donut__inner">
                <strong>{{ feedbackDashboardSummary.total }}</strong>
                <small>registros</small>
              </div>
            </div>
            <div class="dashboard-v2-demographic-list">
              <div class="dashboard-v2-demographic-row">
                <span><i style="background:#1ec2bf"></i>Aplicados</span>
                <strong>{{ feedbackDashboardSummary.applied }}</strong>
              </div>
              <div class="dashboard-v2-demographic-row">
                <span><i style="background:#f0cb59"></i>Agendados</span>
                <strong>{{ feedbackDashboardSummary.scheduled }}</strong>
              </div>
              <div class="dashboard-v2-demographic-row">
                <span><i style="background:#9aa9bf"></i>Rascunhos</span>
                <strong>{{ feedbackDashboardSummary.draft }}</strong>
              </div>
            </div>
          </div>
        </article>

        <article class="card dashboard-v2-card dashboard-v2-card--feedback-department">
          <header class="dashboard-v2-card__head">
            <h3>Aplicações por departamento</h3>
            <span>Feedbacks aplicados</span>
          </header>
          <div class="dashboard-v2-reasons">
            <div class="dashboard-v2-reason-row" *ngFor="let row of feedbackDepartmentRows">
              <div class="dashboard-v2-reason-row__top">
                <span>{{ row.label }}</span>
                <strong>{{ row.count }}</strong>
              </div>
              <div class="mini-bar">
                <div class="mini-bar__fill mini-bar__fill--primary" [style.width.%]="getBarPercent(row.count, feedbackDepartmentMax)"></div>
              </div>
            </div>
            <div class="empty" *ngIf="!feedbackDepartmentRows.length">Sem feedback aplicado para o filtro atual.</div>
          </div>
        </article>

        <article class="card dashboard-v2-card dashboard-v2-card--feedback-recent">
          <header class="dashboard-v2-card__head">
            <h3>Últimos feedbacks aplicados</h3>
            <span>{{ feedbackRecentAppliedRows.length }} registro(s)</span>
          </header>
          <div class="dashboard-v2-birthdays">
            <div class="dashboard-v2-birthday-item" *ngFor="let item of feedbackRecentAppliedRows">
              <span class="avatar">{{ (item.employee_name || 'C').charAt(0) | uppercase }}</span>
              <div>
                <strong>{{ item.employee_name }}</strong>
                <small>{{ item.template_title }} · {{ item.applied_at ? (item.applied_at | date:'short') : 'sem data' }}</small>
              </div>
            </div>
            <div class="empty" *ngIf="!feedbackRecentAppliedRows.length">
              Nenhum feedback aplicado até o momento.
            </div>
          </div>
        </article>

        <article class="card dashboard-v2-card dashboard-v2-card--feedback-questions">
          <header class="dashboard-v2-card__head">
            <h3>Perguntas e respostas</h3>
            <span>{{ feedbackQuestionInsightsTemplateTitle || 'Selecione um template' }}</span>
          </header>
          <div class="empty" *ngIf="feedbackQuestionInsightsMessage">
            {{ feedbackQuestionInsightsMessage }}
          </div>
          <div class="dashboard-feedback-question-list" *ngIf="!feedbackQuestionInsightsMessage && feedbackQuestionInsights.length">
            <article class="dashboard-feedback-question-card" *ngFor="let insight of feedbackQuestionInsights">
              <div class="dashboard-feedback-question-card__head">
                <strong>{{ insight.title }}</strong>
                <small>{{ insight.total_answers }} resposta(s)</small>
              </div>
              <div class="dashboard-feedback-question-card__stats" *ngIf="insight.stats">
                <span>Mín: {{ insight.stats.min ?? '—' }}</span>
                <span>Média: {{ insight.stats.average ?? '—' }}</span>
                <span>Máx: {{ insight.stats.max ?? '—' }}</span>
              </div>
              <div class="dashboard-v2-reasons">
                <div class="dashboard-v2-reason-row" *ngFor="let option of insight.options">
                  <div class="dashboard-v2-reason-row__top">
                    <span>{{ option.label }}</span>
                    <strong>{{ option.count }} · {{ option.percent | number:'1.0-1' }}%</strong>
                  </div>
                  <div class="mini-bar">
                    <div class="mini-bar__fill mini-bar__fill--primary" [style.width.%]="feedbackQuestionOptionBarWidth(option.percent)"></div>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </article>
      </section>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="activeTab === 'collaborators'">
    <section class="panel card">
      <div class="panel-header">
        <div>
          <h2>Colaboradores</h2>
          <p>Cadastre e acompanhe o histórico completo de cada colaborador.</p>
        </div>
        <div class="panel-actions">
          <mat-form-field appearance="outline" class="digital-field modal-standard-field cp-search-field cp-search-field--table dp-table-search-field">
            <mat-icon matPrefix>search</mat-icon>
            <input
              matInput
              type="text"
              placeholder="Pesquise o colaborador..."
              aria-label="Pesquisar colaborador"
              [(ngModel)]="filterTerm"
              (ngModelChange)="onEmployeeSearchChange()">
          </mat-form-field>
        </div>
      </div>

      <div class="table-wrapper" *ngIf="!loading">
        <table>
          <thead>
            <tr>
              <th>Colaborador</th>
              <th>Matrícula</th>
              <th>Cargo</th>
              <th>Setor</th>
              <th>Status</th>
              <th>Admissão</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let emp of pagedEmployees">
              <td>
                <strong>{{ emp.full_name }}</strong>
                <small>{{ emp.cpf || 'Sem CPF' }}</small>
              </td>
              <td>{{ emp.employee_code || '—' }}</td>
              <td class="role-cell">{{ emp.role_name || '—' }}</td>
              <td class="sector-cell">{{ emp.sector_name || emp.department_name || '—' }}</td>
              <td>
                <span class="status-pill" [ngClass]="emp.status?.toLowerCase()">{{ statusLabel(emp.status) }}</span>
              </td>
              <td>{{ emp.hired_at ? (emp.hired_at | date:'shortDate') : '—' }}</td>
              <td class="actions">
                <button type="button" class="action-icon" title="Editar" aria-label="Editar" (click)="openEmployeeModal(emp)">
                  <mat-icon>edit</mat-icon>
                </button>
                <button type="button" class="action-icon" title="Ocorrência" aria-label="Ocorrência" (click)="openOccurrenceModal(emp)">
                  <mat-icon>event_note</mat-icon>
                </button>
                <button
                  type="button"
                  class="action-icon action-icon--one-on-one"
                  title="Feedback 1:1"
                  aria-label="Feedback 1:1"
                  (click)="openEmployeeFeedbackModal(emp)">
                  <span>1:1</span>
                </button>
                <button type="button" class="action-icon" title="Histórico" aria-label="Histórico" (click)="openHistoryModal(emp)">
                  <mat-icon>history</mat-icon>
                </button>
              </td>
            </tr>
            <tr *ngIf="!filteredEmployees.length">
              <td colspan="7" class="empty">Nenhum colaborador cadastrado.</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-pagination" *ngIf="filteredEmployees.length > pageSize">
        <button type="button" (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1">Anterior</button>
        <span>Página {{ currentPage }} de {{ totalPages }}</span>
        <button type="button" (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages">Próxima</button>
      </div>
      <div class="loading" *ngIf="loading">Carregando colaboradores...</div>
    </section>
  </ng-container>

  <ng-container *ngIf="activeTab === 'digitalAdmissions' && isMaster">
    <section class="panel card">
      <div class="panel-header">
        <div>
          <h2>Admissão digital</h2>
          <p>Acompanhe colaboradores com status relacionados ao processo de admissão digital.</p>
        </div>
        <div class="panel-actions">
          <mat-form-field appearance="outline" class="digital-field modal-standard-field cp-search-field cp-search-field--table dp-table-search-field">
            <mat-icon matPrefix>search</mat-icon>
            <input
              matInput
              type="text"
              placeholder="Pesquise o colaborador..."
              aria-label="Pesquisar colaborador"
              [(ngModel)]="filterTerm"
              (ngModelChange)="onEmployeeSearchChange()">
          </mat-form-field>
        </div>
      </div>

      <div class="table-wrapper" *ngIf="!loading">
        <table>
          <thead>
            <tr>
              <th>Colaborador</th>
              <th>Cargo</th>
              <th>% conclusão</th>
              <th>Status</th>
              <th>Prazo de expiração</th>
              <th>Link</th>
              <th>Alertas</th>
              <th>Admissão</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let emp of pagedDigitalAdmissionEmployees">
              <td>
                <strong>{{ emp.full_name }}</strong>
                <small>{{ emp.cpf || 'Sem CPF' }}</small>
              </td>
              <td class="role-cell">{{ emp.role_name || '—' }}</td>
              <td>{{ admissionCompletionPercentage(emp) }}%</td>
              <td>
                <span class="status-pill" [ngClass]="emp.status?.toLowerCase()">{{ statusLabel(emp.status) }}</span>
              </td>
              <td>{{ emp.admission_expires_at ? (emp.admission_expires_at | date:'short') : '—' }}</td>
              <td>
                <div class="admission-link-cell">
                  <span
                    class="status-pill"
                    [ngClass]="{
                      active: admissionLinkStateLabel(emp) === 'Ativo',
                      expired: admissionLinkStateLabel(emp) === 'Expirado'
                    }"
                  >
                    {{ admissionLinkStateLabel(emp) }}
                  </span>
                  <button
                    type="button"
                    class="btn ghost small"
                    *ngIf="canReactivateAdmissionLink(emp)"
                    [disabled]="reactivatingAdmissionEmployeeId === emp.id"
                    (click)="reactivateAdmissionLink(emp)"
                  >
                    {{ reactivatingAdmissionEmployeeId === emp.id ? 'Ativando...' : 'Ativar novamente' }}
                  </button>
                </div>
              </td>
              <td>
                <span class="admission-alert-indicator" [class.has-alert]="(emp.admission_alert_count || 0) > 0">
                  <mat-icon>{{ (emp.admission_alert_count || 0) > 0 ? 'warning_amber' : 'check_circle' }}</mat-icon>
                  <small *ngIf="(emp.admission_alert_count || 0) > 0">{{ emp.admission_alert_count }} alerta(s)</small>
                  <small *ngIf="(emp.admission_alert_count || 0) <= 0">Sem alertas</small>
                </span>
              </td>
              <td>{{ emp.hired_at ? (emp.hired_at | date:'shortDate') : '—' }}</td>
              <td class="actions">
                <button type="button" class="action-icon" title="Editar" aria-label="Editar" (click)="openEmployeeModal(emp)">
                  <mat-icon>edit</mat-icon>
                </button>
                <button type="button" class="action-icon" title="Histórico" aria-label="Histórico" (click)="openHistoryModal(emp)">
                  <mat-icon>history</mat-icon>
                </button>
              </td>
            </tr>
            <tr *ngIf="!filteredDigitalAdmissionEmployees.length">
              <td colspan="9" class="empty">Nenhum colaborador em status de admissão digital.</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-pagination" *ngIf="filteredDigitalAdmissionEmployees.length > pageSize">
        <button type="button" (click)="goToDigitalAdmissionPage(digitalAdmissionPage - 1)" [disabled]="digitalAdmissionPage === 1">Anterior</button>
        <span>Página {{ digitalAdmissionPage }} de {{ digitalAdmissionTotalPages }}</span>
        <button type="button" (click)="goToDigitalAdmissionPage(digitalAdmissionPage + 1)" [disabled]="digitalAdmissionPage === digitalAdmissionTotalPages">Próxima</button>
      </div>
      <div class="loading" *ngIf="loading">Carregando colaboradores...</div>
    </section>
  </ng-container>

  <ng-container *ngIf="activeTab === 'imports' && isAdmin">
    <section class="panel card">
      <div class="panel-header">
        <div>
          <h2>Importações</h2>
          <p>Importe bases de colaboradores, faltas e atrasos com preview antes de salvar.</p>
        </div>
      </div>

      <div class="import-cards">
        <article class="import-card" *ngFor="let card of importCards">
          <div>
            <h3>{{ card.title }}</h3>
            <p>{{ card.description }}</p>
          </div>
          <div class="import-actions">
            <button class="btn ghost" type="button" (click)="downloadImportTemplate(card.key)">
              Baixar modelo
            </button>
            <button class="btn primary" type="button" (click)="openImportModal(card.key)">
              Selecionar planilha
            </button>
          </div>
        </article>
      </div>

      <div class="import-lookups">
        <h3>Planilhas de referência</h3>
        <div class="lookup-actions">
          <button class="btn ghost" type="button" [disabled]="exportLoading" (click)="downloadLookupSheet('sectors')">
            Baixar setores (id, nome)
          </button>
          <button class="btn ghost" type="button" [disabled]="exportLoading" (click)="downloadLookupSheet('departments')">
            Baixar departamentos (id, setor_id, nome)
          </button>
          <button class="btn ghost" type="button" [disabled]="exportLoading" (click)="downloadLookupSheet('roles')">
            Baixar cargos (id, tenant_id, nome)
          </button>
        </div>
      </div>

      <div class="import-list">
        <h3>Histórico de importações</h3>
        <div class="import-history-list" *ngIf="imports.length; else emptyImports">
          <article class="import-history-card" *ngFor="let imp of imports">
            <div class="import-history-main">
              <div>
                <strong>{{ imp.import_type }}</strong>
                <small>{{ imp.file_name || 'Sem arquivo' }}</small>
              </div>
              <span class="status-pill" [ngClass]="(imp.status || '').toLowerCase()">{{ imp.status }}</span>
            </div>
            <div class="import-history-meta">
              <div>
                <span>Processados</span>
                <strong>{{ imp.processed_count ?? 0 }}</strong>
              </div>
              <div>
                <span>Erros</span>
                <strong>{{ imp.error_count ?? 0 }}</strong>
              </div>
              <div>
                <span>Restantes</span>
                <strong>{{ imp.pending_count ?? 0 }}</strong>
              </div>
              <div>
                <span>Linhas</span>
                <strong>{{ imp.total_rows }}</strong>
              </div>
              <div>
                <span>Data</span>
                <strong>{{ imp.created_at ? (imp.created_at | date:'short') : '—' }}</strong>
              </div>
            </div>
            <div class="import-history-actions" *ngIf="(imp.error_count ?? 0) > 0">
              <button class="btn ghost" type="button" (click)="downloadFailedImportRows(imp)">
                Baixar linhas com erro
              </button>
            </div>
          </article>
        </div>
        <ng-template #emptyImports>
          <div class="empty">Nenhuma importação registrada.</div>
        </ng-template>
      </div>
    </section>
  </ng-container>

</section>

<ng-template #noAccess>
  <section class="empty-state">
    <p>Faça login para acessar o ControlDP.</p>
  </section>
</ng-template>

<div class="modal-backdrop" *ngIf="showFilterModal" (click)="closeFilterModal()"></div>
<aside class="side-modal filter-modal" *ngIf="showFilterModal" (click)="$event.stopPropagation()">
  <header>
    <div>
      <h2>Filtros</h2>
      <p>Refine colaboradores e dashboards do ControlDP.</p>
    </div>
    <button type="button" class="close" (click)="closeFilterModal()">&times;</button>
  </header>
  <div class="cp-modal__body">
    <h4 class="filter-section-title">Filtro colaboradores</h4>
    <mat-form-field appearance="outline" class="digital-field modal-standard-field">
      <mat-label>Setor</mat-label>
      <mat-select [(ngModel)]="filterSectorId" (ngModelChange)="onFilterSectorChange()">
        <mat-option value="">Todos</mat-option>
        <mat-option *ngFor="let sector of sectors" [value]="sector.id">{{ sector.name }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="digital-field modal-standard-field">
      <mat-label>Departamento</mat-label>
      <mat-select [(ngModel)]="filterDepartmentId">
        <mat-option value="">Todos</mat-option>
        <mat-option *ngFor="let dept of availableFilterDepartments" [value]="dept.id">{{ dept.name }}</mat-option>
      </mat-select>
    </mat-form-field>

    <h4 class="filter-section-title">Filtro dashboards</h4>
    <mat-form-field appearance="outline" class="digital-field modal-standard-field">
      <mat-label>Tipo de dashboard</mat-label>
      <mat-select [(ngModel)]="dashboardFilter" (ngModelChange)="onDashboardFilterChange()">
        <mat-option *ngFor="let option of dashboardFilterOptions" [value]="option.value">{{ option.label }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      class="digital-field modal-standard-field"
      *ngIf="dashboardFilter === 'FEEDBACK'">
      <mat-label>Feedback (subfiltro)</mat-label>
      <mat-select [(ngModel)]="feedbackDashboardTemplateId" (ngModelChange)="onDashboardFeedbackTemplateChange()">
        <mat-option value="">Todos os feedbacks</mat-option>
        <mat-option *ngFor="let template of feedbackTemplates" [value]="template.id">{{ template.title }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="entry-footer">
    <button class="btn ghost" type="button" (click)="clearFilters()">Limpar</button>
    <button class="btn primary" type="button" (click)="applyFilters()">Aplicar filtros</button>
  </div>
</aside>

<div class="modal-backdrop" *ngIf="showEmployeeModal" (click)="closeModals()"></div>
<section class="modal wide" *ngIf="showEmployeeModal" (click)="onEmployeeModalClick($event)">
  <header>
    <div>
      <h2>{{ selectedEmployee ? 'Editar colaborador' : 'Novo colaborador' }}</h2>
      <p>Preencha as informações pessoais e corporativas do colaborador.</p>
    </div>
    <button type="button" class="close" (click)="closeModals()">&times;</button>
  </header>

  <div class="modal-body">
    <div class="accordion">
      <details class="accordion-section" [open]="isEmployeeModalSectionOpen('personal')">
        <summary (click)="setEmployeeModalSection('personal', $event)">
          <div>
            <span>Dados pessoais</span>
            <small>Informações principais e documentações do colaborador</small>
          </div>
          <span class="accordion-icon"></span>
        </summary>
        <div class="section-content">
          <div class="employee-photo-card">
            <input #employeePhotoInput type="file" accept="image/*" hidden (change)="onEmployeePhotoSelected($event)">
            <button type="button" class="employee-photo-trigger" [disabled]="employeePhotoUploading" (click)="employeePhotoInput.click()">
              <div class="employee-photo-preview">
                <img [src]="getEmployeePhotoUrl()" alt="Foto do colaborador">
                <div class="employee-photo-overlay">
                  <span>{{ employeePhotoUploading ? 'Enviando foto...' : 'Alterar foto' }}</span>
                </div>
              </div>
              <div class="employee-photo-meta">
                <strong>Foto do colaborador</strong>
                <small>
                  {{ selectedEmployee ? 'Passe o mouse e clique para atualizar a foto.' : 'Após salvar o colaborador, a foto será persistida automaticamente.' }}
                </small>
              </div>
            </button>
          </div>
          <div class="form-grid">
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Nome completo</mat-label>
              <input matInput type="text" [(ngModel)]="employeeForm.full_name">
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Matrícula (opcional)</mat-label>
              <input matInput type="text" [(ngModel)]="employeeForm.employee_code">
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>CPF</mat-label>
              <input matInput type="text" [(ngModel)]="employeeForm.cpf">
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>RG</mat-label>
              <input matInput type="text" [(ngModel)]="employeeForm.rg">
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field employee-date-field">
              <mat-label>Data de nascimento</mat-label>
              <input
                matInput
                [matDatepicker]="employeeBirthDatePicker"
                [(ngModel)]="employeeForm.birth_date"
                [ngModelOptions]="{ updateOn: 'blur' }"
                inputmode="numeric"
                maxlength="10"
                (input)="onEmployeeDateInput($event)"
                (blur)="onEmployeeDateBlur('birth_date', $event)"
                (dateChange)="onEmployeeDateChange('birth_date', $event)"
              >
              <mat-datepicker-toggle matSuffix [for]="employeeBirthDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #employeeBirthDatePicker></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Idade</mat-label>
              <input matInput type="text" [value]="getAgeLabel()" readonly>
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Gênero</mat-label>
              <mat-select [(ngModel)]="employeeForm.gender">
                <mat-option value="NOT_INFORMED">Selecione</mat-option>
                <mat-option value="F">Feminino</mat-option>
                <mat-option value="M">Masculino</mat-option>
                <mat-option value="OTHER">Outro</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Estado civil</mat-label>
              <mat-select [(ngModel)]="employeeForm.marital_status">
                <mat-option value="">Selecione</mat-option>
                <mat-option *ngFor="let status of maritalStatusOptions" [value]="status">{{ status }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Local de nascimento</mat-label>
              <input matInput type="text" [(ngModel)]="employeeForm.birth_location">
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Raça/Cor</mat-label>
              <mat-select [(ngModel)]="employeeForm.race">
                <mat-option value="">Selecione</mat-option>
                <mat-option *ngFor="let option of raceOptions" [value]="option">{{ option }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Nome da mãe</mat-label>
              <input matInput type="text" [(ngModel)]="employeeForm.mother_name">
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Nome do pai</mat-label>
              <input matInput type="text" [(ngModel)]="employeeForm.father_name">
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Escolaridade</mat-label>
              <mat-select [(ngModel)]="employeeForm.education_level">
                <mat-option value="">Selecione</mat-option>
                <mat-option *ngFor="let option of educationLevelOptions" [value]="option">{{ option }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </details>
      <details class="accordion-section" [open]="isEmployeeModalSectionOpen('contact')">
        <summary (click)="setEmployeeModalSection('contact', $event)">
          <div>
            <span>Endereço e contatos</span>
            <small>Informações de localização e formas de contato</small>
          </div>
          <span class="accordion-icon"></span>
        </summary>
        <div class="section-content">
          <div class="form-grid">
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>CEP</mat-label>
              <input matInput type="text" [(ngModel)]="employeeForm.cep">
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Rua</mat-label>
              <input matInput type="text" [(ngModel)]="employeeForm.street">
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Número</mat-label>
              <input matInput type="text" [(ngModel)]="employeeForm.number">
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Complemento</mat-label>
              <input matInput type="text" [(ngModel)]="employeeForm.complement">
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Bairro</mat-label>
              <input matInput type="text" [(ngModel)]="employeeForm.neighborhood">
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Cidade</mat-label>
              <input matInput type="text" [(ngModel)]="employeeForm.city">
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Estado</mat-label>
              <input matInput type="text" [(ngModel)]="employeeForm.state">
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Telefone</mat-label>
              <input matInput type="text" [(ngModel)]="employeeForm.phone">
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>E-mail pessoal</mat-label>
              <input matInput type="email" [(ngModel)]="employeeForm.personal_email">
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Contato de emergência</mat-label>
              <input matInput type="text" [(ngModel)]="employeeForm.emergency_contact_name">
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Telefone de emergência</mat-label>
              <input matInput type="text" [(ngModel)]="employeeForm.emergency_contact_phone">
            </mat-form-field>
          </div>
        </div>
      </details>
      <details class="accordion-section" [open]="isEmployeeModalSectionOpen('corporate')">
        <summary (click)="setEmployeeModalSection('corporate', $event)">
          <div>
            <span>Dados corporativos</span>
            <small>Integração com folha, salario e vínculos internos</small>
          </div>
          <span class="accordion-icon"></span>
        </summary>
        <div class="section-content">
          <div class="form-grid">
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Status</mat-label>
              <mat-select [(ngModel)]="employeeForm.status">
                <mat-option value="ACTIVE">Ativo</mat-option>
                <mat-option value="INACTIVE">Inativo</mat-option>
                <mat-option value="ON_LEAVE">Afastado</mat-option>
                <mat-option value="TERMINATED">Desligado</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>E-mail corporativo</mat-label>
              <input matInput type="email" [(ngModel)]="employeeForm.corporate_email">
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field employee-date-field">
              <mat-label>Data de admissão</mat-label>
              <input
                matInput
                [matDatepicker]="employeeHiredDatePicker"
                [(ngModel)]="employeeForm.hired_at"
                [ngModelOptions]="{ updateOn: 'blur' }"
                inputmode="numeric"
                maxlength="10"
                (input)="onEmployeeDateInput($event)"
                (blur)="onEmployeeDateBlur('hired_at', $event)"
                (dateChange)="onEmployeeDateChange('hired_at', $event)"
              >
              <mat-datepicker-toggle matSuffix [for]="employeeHiredDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #employeeHiredDatePicker></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Cargo</mat-label>
              <mat-select [(ngModel)]="employeeForm.role_id" (ngModelChange)="onRoleChange()">
                <mat-option value="">Selecione</mat-option>
                <mat-option *ngFor="let role of roles" [value]="role.id">{{ role.name }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field employee-date-field">
              <mat-label>Experiência 45 dias</mat-label>
              <input
                matInput
                [matDatepicker]="employeeExperience45DatePicker"
                [(ngModel)]="employeeForm.experience_45_days"
                [ngModelOptions]="{ updateOn: 'blur' }"
                inputmode="numeric"
                maxlength="10"
                (input)="onEmployeeDateInput($event)"
                (blur)="onEmployeeDateBlur('experience_45_days', $event)"
                (dateChange)="onEmployeeDateChange('experience_45_days', $event)"
                disabled
              >
              <mat-datepicker-toggle matSuffix [for]="employeeExperience45DatePicker"></mat-datepicker-toggle>
              <mat-datepicker #employeeExperience45DatePicker></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field employee-date-field">
              <mat-label>Experiência 90 dias</mat-label>
              <input
                matInput
                [matDatepicker]="employeeExperience90DatePicker"
                [(ngModel)]="employeeForm.experience_90_days"
                [ngModelOptions]="{ updateOn: 'blur' }"
                inputmode="numeric"
                maxlength="10"
                (input)="onEmployeeDateInput($event)"
                (blur)="onEmployeeDateBlur('experience_90_days', $event)"
                (dateChange)="onEmployeeDateChange('experience_90_days', $event)"
                disabled
              >
              <mat-datepicker-toggle matSuffix [for]="employeeExperience90DatePicker"></mat-datepicker-toggle>
              <mat-datepicker #employeeExperience90DatePicker></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Salário</mat-label>
              <input matInput type="number" step="0.01" [(ngModel)]="employeeForm.salary">
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Tipo de contrato</mat-label>
              <mat-select [(ngModel)]="employeeForm.contract_type">
                <mat-option value="">Selecione</mat-option>
                <mat-option *ngFor="let option of contractTypeOptions" [value]="option">{{ option }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Código eSocial</mat-label>
              <input matInput type="text" [(ngModel)]="employeeForm.esocial_code">
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Número CTPS</mat-label>
              <input matInput type="text" [(ngModel)]="employeeForm.ctps_number">
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>PIS</mat-label>
              <input matInput type="text" [(ngModel)]="employeeForm.pis">
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>PCD</mat-label>
              <mat-select [(ngModel)]="employeeForm.pcd">
                <mat-option [value]="0">Não</mat-option>
                <mat-option [value]="1">Sim</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>CBO</mat-label>
              <input matInput type="text" [(ngModel)]="employeeForm.cbo_code">
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Banco</mat-label>
              <input matInput type="text" [(ngModel)]="employeeForm.bank">
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Agência</mat-label>
              <input matInput type="text" [(ngModel)]="employeeForm.bank_branch">
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Conta</mat-label>
              <input matInput type="text" [(ngModel)]="employeeForm.bank_account">
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Tipo de conta</mat-label>
              <mat-select [(ngModel)]="employeeForm.bank_account_type">
                <mat-option value="">Selecione</mat-option>
                <mat-option *ngFor="let option of bankAccountTypes" [value]="option">{{ option }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <mat-form-field appearance="outline" class="digital-field modal-standard-field wide-field">
            <mat-label>Observações</mat-label>
            <textarea matInput rows="3" [(ngModel)]="employeeForm.notes"></textarea>
          </mat-form-field>
        </div>
      </details>
      <details class="accordion-section" [open]="isEmployeeModalSectionOpen('structure')">
        <summary (click)="setEmployeeModalSection('structure', $event)">
          <div>
            <span>Vínculos e estrutura</span>
            <small>Conecte o colaborador à organização</small>
          </div>
          <span class="accordion-icon"></span>
        </summary>
        <div class="section-content">
          <div class="form-grid">
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Setor</mat-label>
              <mat-select [(ngModel)]="employeeForm.sector_id" (ngModelChange)="onSectorChange()">
                <mat-option value="">Selecione</mat-option>
                <mat-option *ngFor="let sector of sectors" [value]="sector.id">{{ sector.name }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Departamento</mat-label>
              <mat-select [(ngModel)]="employeeForm.department_id" (ngModelChange)="onDepartmentChange()">
                <mat-option value="">Selecione</mat-option>
                <mat-option *ngFor="let dept of availableDepartments" [value]="dept.id">{{ dept.name }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Local</mat-label>
              <mat-select [(ngModel)]="employeeForm.location_id">
                <mat-option value="">Selecione</mat-option>
                <mat-option *ngFor="let loc of availableLocations" [value]="loc.id">{{ loc.name }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </details>
      <details class="accordion-section" [open]="isEmployeeModalSectionOpen('documents')">
        <summary (click)="setEmployeeModalSection('documents', $event)">
          <div>
            <span>Documentos e anexos</span>
            <small>Mantenha os registros atualizados</small>
          </div>
          <span class="accordion-icon"></span>
        </summary>
        <div class="section-content">
          <div class="documents-tabs">
            <button
              type="button"
              [class.active]="employeeDocsTab === 'controldocs'"
              (click)="setEmployeeDocsTab('controldocs')">
              ControlDocs
            </button>
            <button
              type="button"
              [class.active]="employeeDocsTab === 'attachments'"
              (click)="setEmployeeDocsTab('attachments')">
              Anexos internos
            </button>
          </div>

          <div class="docs-error" *ngIf="employeeDocsTab === 'controldocs' && employeeDocsError">
            {{ employeeDocsError }}
          </div>

          <div class="controldocs-panel" *ngIf="employeeDocsTab === 'controldocs'">
            <div class="empty" *ngIf="!selectedEmployee">
              Salve o colaborador para habilitar o ControlDocs.
            </div>
            <div class="loading" *ngIf="selectedEmployee && employeeDocsLoading">Carregando documentos...</div>
            <div class="controldocs-grid" *ngIf="selectedEmployee && !employeeDocsLoading">
              <article class="controldocs-category" *ngFor="let category of employeeDocsCategories">
                <header>
                  <div>
                    <h4>{{ category.label }}</h4>
                    <small>{{ category.helper }}</small>
                  </div>
                  <span>{{ employeeDocsByCategory[category.key].length }}</span>
                </header>
                <div
                  class="dropzone controldocs-dropzone"
                  [class.dragging]="employeeDocsDraggingCategory === category.key"
                  (dragover)="onEmployeeDocsDragOver($event, category.key)"
                  (dragleave)="onEmployeeDocsDragLeave($event, category.key)"
                  (drop)="onEmployeeDocsDrop($event, category.key)"
                  (click)="docsInput.click()">
                  <input #docsInput type="file" hidden (change)="onEmployeeDocsSelected($event, category.key)">
                  <p>Arraste ou selecione arquivo da categoria.</p>
                  <small>
                    {{ employeeDocsUploadingCategory === category.key ? 'Enviando arquivo...' : 'Clique para selecionar' }}
                  </small>
                </div>
                <ul class="controldocs-list">
                  <li *ngFor="let file of employeeDocsByCategory[category.key]; trackBy: employeeDocTrackBy">
                    <div class="doc-file-row">
                      <button
                        type="button"
                        class="doc-file-thumb"
                        [class.doc-file-thumb--image]="isImageFile(file.name, file.file_type)"
                        [class.doc-file-thumb--pdf]="isPdfFile(file.name, file.file_type)"
                        (click)="openEmployeeDocPreview(file)"
                        [attr.aria-label]="'Visualizar ' + file.name">
                        <img
                          *ngIf="isImageFile(file.name, file.file_type)"
                          [src]="formatAttachmentUrl(file.file_path)"
                          [alt]="file.name" />
                        <span *ngIf="!isImageFile(file.name, file.file_type)">
                          {{ fileThumbLabel(file.name, file.file_type) }}
                        </span>
                      </button>
                      <button type="button" class="file-name-button" (click)="openEmployeeDocPreview(file)">
                        {{ file.name }}
                      </button>
                    </div>
                    <div class="meta">
                      <small>{{ file.uploaded_at | date:'short' }}</small>
                      <div class="file-actions">
                        <button
                          type="button"
                          class="btn ghost small"
                          *ngIf="canPreviewFile(file.name, file.file_type)"
                          (click)="openEmployeeDocPreview(file)">
                          Visualizar
                        </button>
                        <a class="btn ghost small" [href]="formatAttachmentUrl(file.file_path)" target="_blank" rel="noopener">
                          Abrir
                        </a>
                        <button
                          type="button"
                          class="btn ghost small"
                          [disabled]="employeeDocsDeletingFileId === file.id"
                          (click)="removeEmployeeDoc(category.key, file)">
                          {{ employeeDocsDeletingFileId === file.id ? 'Removendo...' : 'Remover' }}
                        </button>
                      </div>
                    </div>
                  </li>
                  <li *ngIf="!employeeDocsByCategory[category.key].length" class="empty">
                    Nenhum documento nesta categoria.
                  </li>
                </ul>
              </article>
            </div>

            <section class="docs-preview" *ngIf="employeeDocsPreview && employeeDocsTab === 'controldocs'">
              <div class="docs-preview__header">
                <div>
                  <strong>{{ employeeDocsPreview.name }}</strong>
                  <small *ngIf="employeeDocsPreview.created_at">{{ employeeDocsPreview.created_at | date:'short' }}</small>
                </div>
                <div class="docs-preview__actions">
                  <a class="btn ghost small" [href]="formatAttachmentUrl(employeeDocsPreview.path)" target="_blank" rel="noopener">
                    Abrir em nova aba
                  </a>
                  <button type="button" class="btn ghost small" (click)="closeEmployeeDocPreview()">Fechar</button>
                </div>
              </div>
              <div class="docs-preview__body" *ngIf="isImageFile(employeeDocsPreview.name, employeeDocsPreview.file_type)">
                <img [src]="formatAttachmentUrl(employeeDocsPreview.path)" [alt]="employeeDocsPreview.name">
              </div>
              <div class="docs-preview__body docs-preview__body--pdf" *ngIf="isPdfFile(employeeDocsPreview.name, employeeDocsPreview.file_type)">
                <iframe [attr.src]="formatAttachmentUrl(employeeDocsPreview.path)" title="Pré-visualização PDF"></iframe>
              </div>
              <div class="docs-preview__body docs-preview__body--fallback" *ngIf="!canPreviewFile(employeeDocsPreview.name, employeeDocsPreview.file_type)">
                <p>Pré-visualização não disponível para este arquivo.</p>
              </div>
            </section>
          </div>

          <div class="attachments-panel" *ngIf="employeeDocsTab === 'attachments'">
            <div class="attachments-dropzone">
              <div
                class="dropzone"
                [class.dragging]="attachmentDragging"
                (dragover)="onAttachmentDragOver($event)"
                (dragleave)="onAttachmentDragLeave($event)"
                (drop)="onAttachmentDrop($event)"
                (click)="attachmentInput.click()"
              >
                <input #attachmentInput type="file" (change)="onAttachmentSelected($event)" hidden>
                <p>Arraste ou selecione o documento do colaborador.</p>
                <small>Pronto para anexar um novo arquivo.</small>
              </div>
            </div>
            <div class="attachments-list">
              <h4>Anexos</h4>
              <div *ngIf="!attachments.length" class="empty">Nenhum anexo registrado.</div>
              <ul>
                <li *ngFor="let doc of attachments">
                  <div class="doc-file-row">
                    <button
                      type="button"
                      class="doc-file-thumb"
                      [class.doc-file-thumb--image]="isImageFile(doc.file_name, doc.file_type)"
                      [class.doc-file-thumb--pdf]="isPdfFile(doc.file_name, doc.file_type)"
                      (click)="openAttachmentPreview(doc)"
                      [attr.aria-label]="'Visualizar ' + doc.file_name">
                      <img
                        *ngIf="isImageFile(doc.file_name, doc.file_type)"
                        [src]="formatAttachmentUrl(doc.file_path)"
                        [alt]="doc.file_name" />
                      <span *ngIf="!isImageFile(doc.file_name, doc.file_type)">
                        {{ fileThumbLabel(doc.file_name, doc.file_type) }}
                      </span>
                    </button>
                    <button type="button" class="file-name-button" (click)="openAttachmentPreview(doc)">
                      {{ doc.file_name }}
                    </button>
                  </div>
                  <div class="meta">
                    <small>{{ doc.created_at | date:'short' }}</small>
                    <div class="file-actions">
                      <button
                        type="button"
                        class="btn ghost small"
                        *ngIf="canPreviewFile(doc.file_name, doc.file_type)"
                        (click)="openAttachmentPreview(doc)">
                        Visualizar
                      </button>
                      <a class="btn ghost small" [href]="formatAttachmentUrl(doc.file_path)" target="_blank" rel="noopener">
                        Abrir
                      </a>
                    </div>
                  </div>
                </li>
              </ul>

              <section class="docs-preview" *ngIf="employeeDocsPreview && employeeDocsTab === 'attachments'">
                <div class="docs-preview__header">
                  <div>
                    <strong>{{ employeeDocsPreview.name }}</strong>
                    <small *ngIf="employeeDocsPreview.created_at">{{ employeeDocsPreview.created_at | date:'short' }}</small>
                  </div>
                  <div class="docs-preview__actions">
                    <a class="btn ghost small" [href]="formatAttachmentUrl(employeeDocsPreview.path)" target="_blank" rel="noopener">
                      Abrir em nova aba
                    </a>
                    <button type="button" class="btn ghost small" (click)="closeEmployeeDocPreview()">Fechar</button>
                  </div>
                </div>
                <div class="docs-preview__body" *ngIf="isImageFile(employeeDocsPreview.name, employeeDocsPreview.file_type)">
                  <img [src]="formatAttachmentUrl(employeeDocsPreview.path)" [alt]="employeeDocsPreview.name">
                </div>
                <div class="docs-preview__body docs-preview__body--pdf" *ngIf="isPdfFile(employeeDocsPreview.name, employeeDocsPreview.file_type)">
                  <iframe [attr.src]="formatAttachmentUrl(employeeDocsPreview.path)" title="Pré-visualização PDF"></iframe>
                </div>
                <div class="docs-preview__body docs-preview__body--fallback" *ngIf="!canPreviewFile(employeeDocsPreview.name, employeeDocsPreview.file_type)">
                  <p>Pré-visualização não disponível para este arquivo.</p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </details>
    </div>
  </div>

  <div class="modal-actions">
    <button class="btn ghost" type="button" (click)="closeModals()">Cancelar</button>
    <button class="btn primary" type="button" (click)="saveEmployee()">Salvar colaborador</button>
  </div>
</section>

<div class="modal-backdrop" *ngIf="showEmployeeFeedbackModal" (click)="closeEmployeeFeedbackModal()"></div>
<section class="modal modal-card wide cad-feedback-employee-modal" *ngIf="showEmployeeFeedbackModal" (click)="$event.stopPropagation()">
  <header class="modal-header">
    <div>
      <span class="cad-modal-eyebrow">ControlDP · Feedback 1:1</span>
      <h2>Feedback do colaborador</h2>
      <small *ngIf="employeeFeedbackTarget">
        {{ employeeFeedbackTarget.full_name }} · {{ employeeFeedbackTarget.role_name || 'Sem cargo' }}
      </small>
      <small *ngIf="!employeeFeedbackTarget">Selecione o template e registre a ação.</small>
    </div>
    <button class="icon" type="button" (click)="closeEmployeeFeedbackModal()">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="cp-modal-body">
    <div class="cp-tabs">
      <button
        mat-stroked-button
        type="button"
        *ngFor="let tab of employeeFeedbackTabs"
        [class.active]="employeeFeedbackTab === tab.value"
        (click)="onEmployeeFeedbackTabClick($event, tab.value)">
        <mat-icon>{{ tab.icon }}</mat-icon>
        {{ tab.label }}
      </button>
    </div>

    <div class="cp-modal-scroll">
      <section class="panel cp-project-modal-panel cp-employee-feedback-panel">
        <ng-container *ngIf="employeeFeedbackTab === 'REGISTRO'; else employeeFeedbackListView">
          <div class="cp-form-row feedback-main-grid employee-feedback-form-grid">
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Template de feedback</mat-label>
              <mat-select [(ngModel)]="employeeFeedbackForm.feedback_template_id" (ngModelChange)="onEmployeeFeedbackTemplateChange($event)">
                <mat-option value="">Selecione</mat-option>
                <mat-option *ngFor="let item of availableEmployeeFeedbackTemplates" [value]="item.id">
                  {{ item.title }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Agendar para</mat-label>
              <input matInput type="datetime-local" [(ngModel)]="employeeFeedbackForm.scheduled_for">
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field feedback-full">
              <mat-label>Observações internas</mat-label>
              <textarea matInput rows="3" [(ngModel)]="employeeFeedbackForm.notes" placeholder="Observações internas do feedback"></textarea>
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field feedback-full">
              <mat-label>Observações extras do colaborador</mat-label>
              <textarea matInput rows="3" [(ngModel)]="employeeFeedbackForm.collaborator_notes" placeholder="Observações adicionais do colaborador"></textarea>
            </mat-form-field>
            <small class="feedback-help feedback-full" *ngIf="!availableEmployeeFeedbackTemplates.length">
              Nenhum template disponível para o setor/departamento deste colaborador.
            </small>
          </div>

          <section class="feedback-question-builder employee-feedback-answer-builder">
            <div class="feedback-question-builder__header">
              <h3>Formulário de perguntas</h3>
              <small *ngIf="employeeFeedbackQuestions.length">{{ employeeFeedbackQuestions.length }} pergunta(s)</small>
            </div>

            <div class="loading" *ngIf="employeeFeedbackQuestionsLoading">Carregando perguntas...</div>
            <div class="empty" *ngIf="!employeeFeedbackQuestionsLoading && !employeeFeedbackForm.feedback_template_id">
              Selecione o template para responder o formulário.
            </div>
            <div class="empty" *ngIf="!employeeFeedbackQuestionsLoading && employeeFeedbackForm.feedback_template_id && !employeeFeedbackQuestions.length">
              Esse template não possui perguntas disponíveis.
            </div>

            <div class="feedback-question-list employee-feedback-answer-list" *ngIf="!employeeFeedbackQuestionsLoading && employeeFeedbackQuestions.length">
              <article class="feedback-question-card" *ngFor="let question of employeeFeedbackQuestions; let questionIndex = index">
                <div class="feedback-question-card__header">
                  <strong>Pergunta {{ questionIndex + 1 }}</strong>
                  <span *ngIf="question.required">Obrigatória</span>
                </div>
                <p class="feedback-answer-title">{{ question.title }}</p>
                <p class="feedback-answer-description" *ngIf="question.description">{{ question.description }}</p>

                <div class="feedback-answer-control" *ngIf="isEmployeeFeedbackChoiceQuestion(question)">
                  <select
                    [ngModel]="employeeFeedbackQuestionAnswer(question.id)"
                    (ngModelChange)="setEmployeeFeedbackQuestionAnswer(question.id, $event)">
                    <option value="">Selecione</option>
                    <option *ngFor="let option of question.options" [value]="employeeFeedbackOptionValue(option)">
                      {{ option.label }}
                    </option>
                  </select>
                </div>

                <div class="feedback-answer-control feedback-multi-options" *ngIf="isEmployeeFeedbackMultipleQuestion(question)">
                  <label class="feedback-multi-option" *ngFor="let option of question.options">
                    <input
                      type="checkbox"
                      [checked]="isEmployeeFeedbackOptionChecked(question.id, employeeFeedbackOptionValue(option))"
                      (change)="toggleEmployeeFeedbackOption(question.id, employeeFeedbackOptionValue(option), $any($event.target).checked)">
                    <span>{{ option.label }}</span>
                  </label>
                </div>

                <div class="feedback-answer-control" *ngIf="isEmployeeFeedbackNumberQuestion(question)">
                  <input
                    type="number"
                    [ngModel]="employeeFeedbackQuestionAnswer(question.id)"
                    (ngModelChange)="setEmployeeFeedbackQuestionAnswer(question.id, $event)"
                    placeholder="Digite um número">
                </div>

                <div class="feedback-answer-control" *ngIf="isEmployeeFeedbackDateQuestion(question)">
                  <input
                    type="date"
                    [ngModel]="employeeFeedbackQuestionAnswer(question.id)"
                    (ngModelChange)="setEmployeeFeedbackQuestionAnswer(question.id, $event)">
                </div>

                <div class="feedback-answer-control" *ngIf="isEmployeeFeedbackEmailQuestion(question)">
                  <input
                    type="email"
                    [ngModel]="employeeFeedbackQuestionAnswer(question.id)"
                    (ngModelChange)="setEmployeeFeedbackQuestionAnswer(question.id, $event)"
                    placeholder="nome@empresa.com">
                </div>

                <div class="feedback-answer-control" *ngIf="!isEmployeeFeedbackChoiceQuestion(question) && !isEmployeeFeedbackMultipleQuestion(question) && !isEmployeeFeedbackNumberQuestion(question) && !isEmployeeFeedbackDateQuestion(question) && !isEmployeeFeedbackEmailQuestion(question)">
                  <textarea
                    rows="3"
                    [ngModel]="employeeFeedbackQuestionAnswer(question.id)"
                    (ngModelChange)="setEmployeeFeedbackQuestionAnswer(question.id, $event)"
                    placeholder="Digite a resposta"></textarea>
                </div>
              </article>
            </div>
          </section>
        </ng-container>

        <ng-template #employeeFeedbackListView>
          <div class="feedback-table-wrap employee-feedback-table">
            <div class="loading" *ngIf="employeeFeedbackLoading">Carregando registros...</div>
            <table *ngIf="!employeeFeedbackLoading && filteredEmployeeFeedbackRecords.length">
              <thead>
                <tr>
                  <th>Template</th>
                  <th>Status</th>
                  <th>Agendado para</th>
                  <th>Aplicado em</th>
                  <th>Criado em</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of filteredEmployeeFeedbackRecords">
                  <td>
                    <strong>{{ row.template_title || 'Template removido' }}</strong>
                    <small *ngIf="row.notes">{{ row.notes }}</small>
                  </td>
                  <td>{{ employeeFeedbackStatusLabel(row.status) }}</td>
                  <td>{{ row.scheduled_for ? (row.scheduled_for | date:'short') : '—' }}</td>
                  <td>{{ row.applied_at ? (row.applied_at | date:'short') : '—' }}</td>
                  <td>{{ row.created_at ? (row.created_at | date:'short') : '—' }}</td>
                  <td class="feedback-table-actions">
                    <button class="btn ghost small" type="button" (click)="editEmployeeFeedbackRecord(row)">Editar</button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="empty" *ngIf="!employeeFeedbackLoading && !filteredEmployeeFeedbackRecords.length">
              Nenhum registro em {{ employeeFeedbackStatusLabel(employeeFeedbackTab).toLowerCase() }}.
            </div>
          </div>
        </ng-template>

        <div class="feedback-inline-error" *ngIf="employeeFeedbackError">{{ employeeFeedbackError }}</div>
      </section>
    </div>
  </div>

  <div class="modal-actions">
    <button class="btn ghost" type="button" (click)="closeEmployeeFeedbackModal()">Fechar</button>
    <ng-container *ngIf="employeeFeedbackTab === 'REGISTRO'">
      <button class="btn ghost" type="button" [disabled]="employeeFeedbackSaving" (click)="saveEmployeeFeedback('DRAFT')">
        {{ employeeFeedbackSaving ? 'Salvando...' : 'Salvar rascunho' }}
      </button>
      <button class="btn ghost" type="button" [disabled]="employeeFeedbackSaving" (click)="saveEmployeeFeedback('SCHEDULED')">
        {{ employeeFeedbackSaving ? 'Salvando...' : 'Agendar' }}
      </button>
      <button class="btn primary" type="button" [disabled]="employeeFeedbackSaving" (click)="saveEmployeeFeedback('APPLIED')">
        {{ employeeFeedbackSaving ? 'Salvando...' : 'Aplicar' }}
      </button>
    </ng-container>
  </div>
</section>

<div class="modal-backdrop" *ngIf="showFeedbackModal" (click)="closeFeedbackModal()"></div>
<section class="modal modal-card wide cad-feedback-modal" *ngIf="showFeedbackModal" (click)="$event.stopPropagation()">
  <header>
    <div>
      <h2>{{ feedbackEditingSurveyId ? 'Editar feedback' : 'Novo feedback' }}</h2>
      <small>Crie e gerencie feedbacks integrados ao ControlQuestion sem gerar link público.</small>
    </div>
    <button type="button" class="close" (click)="closeFeedbackModal()">&times;</button>
  </header>

  <div class="cp-modal-body">
    <div class="cp-tabs">
      <button
        mat-stroked-button
        type="button"
        *ngFor="let tab of feedbackModalTabs"
        [class.active]="feedbackModalTab === tab.value"
        (click)="setFeedbackModalTab(tab.value)">
        <mat-icon>{{ tab.icon }}</mat-icon>
        {{ tab.label }}
      </button>
    </div>

    <div class="cp-modal-scroll">
    <div *ngIf="feedbackModalTab === 'cadastro'">
      <div class="feedback-editing-info" *ngIf="feedbackEditingSurveyId">
        Editando feedback #{{ feedbackEditingSurveyId }}
      </div>
      <div class="loading" *ngIf="feedbackEditorLoading">Carregando feedback para edição...</div>
      <ng-container *ngIf="!feedbackEditorLoading">
        <div class="cp-form-row feedback-main-grid">
          <mat-form-field appearance="outline" class="digital-field modal-standard-field feedback-full">
            <mat-label>Título do feedback</mat-label>
            <input matInput type="text" [(ngModel)]="feedbackForm.title" placeholder="Ex: Feedback de desligamento">
          </mat-form-field>
          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Setor</mat-label>
            <mat-select [(ngModel)]="feedbackForm.sector_ids" (ngModelChange)="onFeedbackSectorMultiChange($event)" multiple>
              <mat-option [value]="feedbackSelectAllSectorsValue">Selecionar todos</mat-option>
              <mat-option *ngFor="let sector of sectors" [value]="sector.id">{{ sector.name }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Departamento</mat-label>
            <mat-select [(ngModel)]="feedbackForm.department_ids" (ngModelChange)="onFeedbackDepartmentMultiChange($event)" multiple>
              <mat-option [value]="feedbackSelectAllDepartmentsValue">Selecionar todos</mat-option>
              <mat-option *ngFor="let dept of feedbackAvailableDepartments" [value]="dept.id">{{ dept.name }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="digital-field modal-standard-field feedback-full">
            <mat-label>Descrição</mat-label>
            <textarea matInput rows="3" [(ngModel)]="feedbackForm.description" placeholder="Descrição interna do feedback"></textarea>
          </mat-form-field>
          <mat-form-field appearance="outline" class="digital-field modal-standard-field feedback-full">
            <mat-label>Texto de abertura (opcional)</mat-label>
            <textarea matInput rows="3" [(ngModel)]="feedbackForm.intro_text" placeholder="Mensagem exibida no início do formulário"></textarea>
          </mat-form-field>
        </div>

      </ng-container>
    </div>

    <div *ngIf="feedbackModalTab === 'perguntas'">
      <div class="loading" *ngIf="feedbackEditorLoading">Carregando perguntas...</div>
      <ng-container *ngIf="!feedbackEditorLoading">
        <section class="feedback-question-builder">
          <div class="feedback-question-builder__header">
            <h3>Perguntas e respostas</h3>
            <button class="btn ghost" type="button" (click)="addFeedbackQuestion()">Adicionar pergunta</button>
          </div>

          <div class="feedback-question-list" *ngIf="feedbackQuestions.length; else feedbackNoQuestions">
            <article class="feedback-question-card" *ngFor="let question of feedbackQuestions; let questionIndex = index">
              <div class="feedback-question-card__header">
                <strong>Pergunta {{ questionIndex + 1 }}</strong>
                <button class="btn ghost small" type="button" (click)="removeFeedbackQuestion(questionIndex)">Remover</button>
              </div>

              <div class="cp-form-row feedback-question-grid">
                <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                  <mat-label>Enunciado</mat-label>
                  <input matInput type="text" [(ngModel)]="question.title" placeholder="Digite a pergunta">
                </mat-form-field>
                <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                  <mat-label>Tipo</mat-label>
                  <mat-select [(ngModel)]="question.question_type" (ngModelChange)="onFeedbackQuestionTypeChange(question)">
                    <mat-option *ngFor="let type of feedbackQuestionTypeOptions" [value]="type.value">{{ type.label }}</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" class="digital-field modal-standard-field feedback-full">
                  <mat-label>Descrição (opcional)</mat-label>
                  <input matInput type="text" [(ngModel)]="question.description" placeholder="Ajuda adicional para o respondente">
                </mat-form-field>
                <div class="toggle-inline">
                  <span>Pergunta obrigatória</span>
                  <label class="switch">
                    <input type="checkbox" [(ngModel)]="question.required">
                    <span class="slider"></span>
                  </label>
                </div>
              </div>

              <div class="feedback-options" *ngIf="feedbackQuestionNeedsOptions(question.question_type)">
                <div class="feedback-options__header">
                  <span>Opções de resposta</span>
                  <button class="btn ghost small" type="button" (click)="addFeedbackOption(question)">Adicionar opção</button>
                </div>
                <div class="feedback-option-row" *ngFor="let option of question.options; let optionIndex = index">
                  <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                    <mat-label>{{ 'Opção ' + (optionIndex + 1) }}</mat-label>
                    <input matInput type="text" [(ngModel)]="question.options[optionIndex].label" [placeholder]="'Opção ' + (optionIndex + 1)">
                  </mat-form-field>
                  <button class="action-icon" type="button" (click)="removeFeedbackOption(question, optionIndex)">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
              </div>
            </article>
          </div>
          <ng-template #feedbackNoQuestions>
            <div class="empty">Adicione ao menos uma pergunta para criar o feedback.</div>
          </ng-template>
        </section>
      </ng-container>
    </div>

    <div class="feedback-table-wrap" *ngIf="feedbackModalTab === 'feedbacks'">
      <div class="loading" *ngIf="feedbackTemplatesLoading">Carregando feedbacks...</div>
      <div class="feedback-inline-error" *ngIf="feedbackTemplatesError">{{ feedbackTemplatesError }}</div>
      <table *ngIf="!feedbackTemplatesLoading && feedbackTemplates.length">
        <thead>
          <tr>
            <th>Título</th>
            <th>Setor</th>
            <th>Departamento</th>
            <th>Criado em</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of feedbackTemplates">
            <td>
              <strong>{{ item.title }}</strong>
              <small *ngIf="item.description">{{ item.description }}</small>
            </td>
            <td>{{ item.sector_names_label || item.sector_name || '—' }}</td>
            <td>{{ item.department_names_label || item.department_name || '—' }}</td>
            <td>{{ item.created_at ? (item.created_at | date:'short') : '—' }}</td>
            <td class="feedback-table-actions">
              <button class="btn ghost small" type="button" (click)="editFeedbackTemplate(item)">Editar</button>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="empty" *ngIf="!feedbackTemplatesLoading && !feedbackTemplates.length">
        Nenhum feedback cadastrado.
      </div>
    </div>

    <div class="feedback-inline-error" *ngIf="feedbackError">{{ feedbackError }}</div>
    </div>
  </div>

  <div class="modal-actions">
    <button
      class="btn ghost"
      type="button"
      *ngIf="feedbackModalTab === 'cadastro' && feedbackEditingSurveyId"
      (click)="startNewFeedbackDraft()">
      Novo feedback
    </button>
    <button class="btn ghost" type="button" (click)="closeFeedbackModal()">Fechar</button>
    <button
      class="btn primary"
      type="button"
      *ngIf="feedbackModalTab === 'cadastro' || feedbackModalTab === 'perguntas'"
      [disabled]="feedbackSaving || feedbackEditorLoading"
      (click)="saveFeedback()">
      {{ feedbackSaving ? 'Salvando...' : (feedbackEditingSurveyId ? 'Salvar alterações' : 'Salvar feedback') }}
    </button>
  </div>
</section>

<div class="modal-backdrop" *ngIf="showOccurrenceModal" (click)="closeModals()"></div>
<section class="modal wide occurrence-modal" *ngIf="showOccurrenceModal" (click)="onOccurrenceModalClick($event)">
  <header>
    <div>
      <h2>Adicionar ocorrência</h2>
      <p>Colaborador: {{ selectedEmployee?.full_name }}</p>
    </div>
    <button type="button" class="close" (click)="closeModals()">&times;</button>
  </header>
  <div class="modal-body">
    <div class="accordion">
      <details class="accordion-section" [open]="isOccurrenceModalSectionOpen('data')">
        <summary (click)="setOccurrenceModalSection('data', $event)">
          <div>
            <span>Dados da ocorrência</span>
            <small>Escolha o tipo, período e contextualize</small>
          </div>
          <span class="accordion-icon"></span>
        </summary>
        <div class="section-content">
          <div class="form-grid">
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Tipo de ocorrência</mat-label>
              <mat-select [(ngModel)]="occurrenceForm.type" (ngModelChange)="onOccurrenceTypeChange()">
                <mat-option value="ABSENCE">Falta</mat-option>
                <mat-option value="LATE">Atraso</mat-option>
                <mat-option value="JUSTIFICATION">Justificativa</mat-option>
                <mat-option value="WARNING_WRITTEN">Advertência escrita</mat-option>
                <mat-option value="WARNING_VERBAL">Advertência verbal</mat-option>
                <mat-option value="SUSPENSION">Suspensão</mat-option>
                <mat-option value="LEAVE">Afastamento</mat-option>
                <mat-option value="CERTIFICATE">Certificado</mat-option>
                <mat-option value="PROMOTION">Promoção de cargo</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field occurrence-date-field">
              <mat-label>Início</mat-label>
              <input
                matInput
                [matDatepicker]="occurrenceStartDatePicker"
                [(ngModel)]="occurrenceForm.start_date"
                [ngModelOptions]="{ updateOn: 'blur' }"
                inputmode="numeric"
                maxlength="10"
                (input)="onOccurrenceDateInput($event)"
                (blur)="onOccurrenceDateBlur('start_date', $event)"
                (dateChange)="onOccurrenceDateChange('start_date', $event)"
              >
              <mat-datepicker-toggle matSuffix [for]="occurrenceStartDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #occurrenceStartDatePicker></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field occurrence-date-field">
              <mat-label>Fim</mat-label>
              <input
                matInput
                [matDatepicker]="occurrenceEndDatePicker"
                [(ngModel)]="occurrenceForm.end_date"
                [ngModelOptions]="{ updateOn: 'blur' }"
                inputmode="numeric"
                maxlength="10"
                (input)="onOccurrenceDateInput($event)"
                (blur)="onOccurrenceDateBlur('end_date', $event)"
                (dateChange)="onOccurrenceDateChange('end_date', $event)"
              >
              <mat-datepicker-toggle matSuffix [for]="occurrenceEndDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #occurrenceEndDatePicker></mat-datepicker>
            </mat-form-field>
            <ng-container *ngIf="occurrenceForm.type === 'PROMOTION'">
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Cargo promovido</mat-label>
                <mat-select [(ngModel)]="occurrenceForm.promoted_role_id">
                  <mat-option value="">Selecione</mat-option>
                  <mat-option *ngFor="let role of roles" [value]="role.id">{{ role.name }}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Salário promovido</mat-label>
                <input matInput type="number" step="0.01" [(ngModel)]="occurrenceForm.promoted_salary">
              </mat-form-field>
            </ng-container>
            <ng-container *ngIf="occurrenceForm.type === 'CERTIFICATE'">
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Instituição</mat-label>
                <input matInput type="text" [(ngModel)]="occurrenceForm.certificate_institution" placeholder="Ex: Universidade X">
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Curso</mat-label>
                <input matInput type="text" [(ngModel)]="occurrenceForm.certificate_course" placeholder="Ex: Gestão de Projetos">
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Modalidade</mat-label>
                <mat-select [(ngModel)]="occurrenceForm.certificate_modality">
                  <mat-option value="">Selecione</mat-option>
                  <mat-option *ngFor="let modality of certificateModalityOptions" [value]="modality">{{ modality }}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Área de conhecimento</mat-label>
                <mat-select [(ngModel)]="occurrenceForm.certificate_knowledge_area">
                  <mat-option value="">Selecione</mat-option>
                  <mat-optgroup *ngFor="let group of certificateKnowledgeAreaGroups" [label]="group.label">
                    <mat-option *ngFor="let option of group.options" [value]="option">{{ option }}</mat-option>
                  </mat-optgroup>
                </mat-select>
              </mat-form-field>
            </ng-container>
          </div>
          <div class="form-grid">
            <mat-form-field appearance="outline" class="digital-field modal-standard-field occurrence-textarea-field">
              <mat-label>Descrição</mat-label>
              <textarea matInput rows="5" [(ngModel)]="occurrenceForm.description"></textarea>
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field occurrence-textarea-field">
              <mat-label>Observações</mat-label>
              <textarea matInput rows="5" [(ngModel)]="occurrenceForm.notes"></textarea>
            </mat-form-field>
          </div>
        </div>
      </details>
      <details class="accordion-section" [open]="isOccurrenceModalSectionOpen('attachments')">
        <summary (click)="setOccurrenceModalSection('attachments', $event)">
          <div>
            <span>Anexo da ocorrência</span>
            <small>Documente evidências ou anexos</small>
          </div>
          <span class="accordion-icon"></span>
        </summary>
        <div class="section-content">
          <div class="occurrence-attachments">
            <div
              class="dropzone"
              [class.dragging]="occurrenceAttachmentDragging"
              (dragover)="onOccurrenceDragOver($event)"
              (dragleave)="onOccurrenceDragLeave($event)"
              (drop)="onOccurrenceFileDrop($event)"
              (click)="occurrenceFileInput.click()"
            >
              <input #occurrenceFileInput type="file" (change)="onOccurrenceFileSelected($event)" hidden>
              <p>Arraste o anexo aqui ou clique para selecionar.</p>
              <small>{{ occurrenceAttachmentName || 'Nenhum arquivo selecionado.' }}</small>
            </div>
            <button class="btn ghost small" type="button" *ngIf="occurrenceAttachmentName" (click)="clearOccurrenceAttachment()">
              Remover anexo
            </button>
          </div>
        </div>
      </details>
      <details class="accordion-section" [open]="isOccurrenceModalSectionOpen('history')">
        <summary (click)="setOccurrenceModalSection('history', $event)">
          <div>
            <span>Histórico de ocorrências</span>
            <small>Resumo das ocorrências já registradas para este colaborador</small>
          </div>
          <span class="accordion-icon"></span>
        </summary>
        <div class="section-content">
          <div class="loading" *ngIf="occurrenceHistoryLoading">Carregando histórico...</div>
          <div class="occurrence-history-list" *ngIf="!occurrenceHistoryLoading">
            <article class="occurrence-history-item" *ngFor="let item of occurrences">
              <div class="occurrence-history-item__head">
                <strong>{{ occurrenceTypeDisplay(item.type) }}</strong>
                <small>{{ item.created_at ? (item.created_at | date:'short') : 'Sem data' }}</small>
              </div>
              <p *ngIf="occurrencePeriodDisplay(item.start_date, item.end_date)" class="occurrence-history-item__line">
                {{ occurrencePeriodDisplay(item.start_date, item.end_date) }}
              </p>
              <p *ngIf="item.description" class="occurrence-history-item__line">
                Descrição: {{ item.description }}
              </p>
              <p *ngIf="item.notes" class="occurrence-history-item__line">
                Observação: {{ item.notes }}
              </p>
              <p *ngIf="item.type === 'CERTIFICATE' && item.certificate_institution" class="occurrence-history-item__line">
                Instituição: {{ item.certificate_institution }}
              </p>
              <p *ngIf="item.type === 'CERTIFICATE' && item.certificate_course" class="occurrence-history-item__line">
                Curso: {{ item.certificate_course }}
              </p>
              <p *ngIf="item.type === 'CERTIFICATE' && item.certificate_modality" class="occurrence-history-item__line">
                Modalidade: {{ item.certificate_modality }}
              </p>
              <p *ngIf="item.type === 'CERTIFICATE' && item.certificate_knowledge_area" class="occurrence-history-item__line">
                Área de conhecimento: {{ item.certificate_knowledge_area }}
              </p>
            </article>
            <div class="empty" *ngIf="!occurrences.length">Nenhuma ocorrência cadastrada para este colaborador.</div>
          </div>
        </div>
      </details>
    </div>
  </div>
  <div class="modal-actions">
    <button class="btn ghost" type="button" (click)="closeModals()">Cancelar</button>
    <button class="btn primary" type="button" (click)="saveOccurrence()">Salvar ocorrência</button>
  </div>
</section>

<div class="modal-backdrop" *ngIf="showHistoryModal" (click)="closeModals()"></div>
<section class="modal modal-card wide cp-history-modal" *ngIf="showHistoryModal" (click)="$event.stopPropagation()">
  <header class="modal-header">
    <div>
      <span class="cad-modal-eyebrow">ControlDP · Histórico</span>
      <h2>Histórico do colaborador</h2>
      <small>{{ selectedEmployee?.full_name || 'Colaborador' }}</small>
    </div>
    <button class="icon" type="button" (click)="closeModals()">
      <mat-icon>close</mat-icon>
    </button>
  </header>
  <div class="cp-modal-body cp-history-modal-body">
    <div class="cp-modal-scroll">
      <section class="panel cp-project-modal-panel cp-history-panel">
        <div class="cp-history-summary" *ngIf="history.length">
          <strong>{{ history.length }} registro(s) no histórico</strong>
        </div>
        <div class="timeline cp-history-timeline">
          <div class="timeline-item" *ngFor="let item of pagedHistory; trackBy: historyItemTrackBy">
            <div class="dot"></div>
            <div class="timeline-item__content">
              <div class="timeline-item__head">
                <span class="timeline-item__badge">{{ item.action_label }}</span>
                <small>{{ item.created_at | date:'short' }}</small>
              </div>
              <strong>{{ item.title }}</strong>
              <p class="timeline-item__line" *ngFor="let line of item.summary_lines">{{ line }}</p>
              <div class="timeline-item__attachments" *ngIf="item.attachments?.length">
                <a
                  *ngFor="let file of item.attachments"
                  class="history-attachment"
                  [href]="formatAttachmentUrl(file.path)"
                  target="_blank"
                  rel="noopener"
                >
                  {{ file.name }}
                </a>
              </div>
              <div class="timeline-item__alert-routes" *ngIf="item.alert_routes?.length">
                <article class="alert-route-card" *ngFor="let route of item.alert_routes">
                  <div class="alert-route-card__head">
                    <div class="alert-route-card__title-block">
                      <strong>{{ route.alert_name }}</strong>
                      <small>{{ route.validation_label }}</small>
                    </div>
                    <span class="alert-route-card__metric">
                      <small>{{ route.measured_title }}</small>
                      <strong>{{ route.measured_label }}</strong>
                    </span>
                  </div>

                  <div class="alert-route-card__meta">
                    <p><span>Condição</span>{{ route.condition_label }}</p>
                    <p><span>Validação</span>{{ route.validation_label }}</p>
                  </div>

                  <div class="alert-route-card__addresses">
                    <p><span>Ponto A · Colaborador</span>{{ route.origin_address }}</p>
                    <p><span>Ponto B · Referência da regra</span>{{ route.destination_address }}</p>
                  </div>

                  <a *ngIf="route.map_path" [href]="route.map_path" target="_blank" rel="noopener" class="alert-route-card__map-link">
                    <img [src]="route.map_path" alt="Mapa do percurso do alerta">
                  </a>

                  <div class="alert-route-card__actions">
                    <a *ngIf="route.directions_url" [href]="route.directions_url" target="_blank" rel="noopener">
                      Abrir rota A → B
                    </a>
                  </div>
                </article>
              </div>
            </div>
          </div>
          <div *ngIf="!history.length" class="empty">Nenhum histórico registrado.</div>
        </div>
      </section>
    </div>
    <div class="table-pagination" *ngIf="history.length > historyPageSize">
      <button type="button" (click)="goToHistoryPage(historyPage - 1)" [disabled]="historyPage === 1">Anterior</button>
      <span>Página {{ historyPage }} de {{ historyTotalPages }}</span>
      <button type="button" (click)="goToHistoryPage(historyPage + 1)" [disabled]="historyPage === historyTotalPages">Próxima</button>
    </div>
  </div>
  <div class="modal-actions">
    <button class="btn ghost" type="button" (click)="closeModals()">Fechar</button>
  </div>
</section>

<div class="modal-backdrop" *ngIf="showDigitalAdmissionModal" (click)="closeDigitalAdmissionModal()"></div>
<section class="modal modal-card wide digital-admission-modal" *ngIf="showDigitalAdmissionModal" (click)="onDigitalAdmissionModalClick($event)">
  <div class="digital-admission-overlay" *ngIf="digitalAdmissionFeedbackState !== 'idle'">
    <div class="digital-admission-overlay__content" [ngSwitch]="digitalAdmissionFeedbackState">
      <ng-container *ngSwitchCase="'loading'">
        <div class="digital-admission-overlay__spinner">
          <img src="../../../assets/MIV/brand/versao 1.png" alt="ControlPS">
        </div>
        <strong>Enviando link...</strong>
        <small>Aguarde enquanto o e-mail é enviado ao colaborador.</small>
      </ng-container>
      <ng-container *ngSwitchCase="'success'">
        <div class="digital-admission-overlay__icon digital-admission-overlay__icon--success">✓</div>
        <strong>E-mail enviado com sucesso!</strong>
        <small>O colaborador receberá o link de admissão digital em instantes.</small>
      </ng-container>
      <ng-container *ngSwitchCase="'error'">
        <div class="digital-admission-overlay__icon digital-admission-overlay__icon--error">!</div>
        <strong>Não foi possível concluir a ação</strong>
        <small>{{ digitalAdmissionFeedbackMessage || 'Tente novamente e confira os dados informados.' }}</small>
        <button class="digital-admission-overlay__action-btn" type="button" (click)="dismissDigitalAdmissionFeedback()">
          Entendi
        </button>
      </ng-container>
    </div>
  </div>
  <header>
    <div>
      <h2>Nova admissão digital</h2>
      <small>Envie o preenchimento assistido ao colaborador com validações automáticas.</small>
    </div>
    <button type="button" class="close" (click)="closeDigitalAdmissionModal()">&times;</button>
  </header>

  <div class="cp-modal-body">
    <div class="cp-modal-scroll">
      <section class="panel">
        <div class="digital-admission-form-surface__head">
          <strong>Dados para envio do link</strong>
          <small>Os campos abaixo seguem o mesmo padrão da página de Admissão Digital.</small>
        </div>
        <div class="cp-form-row digital-admission-grid">
        <mat-form-field
          appearance="outline"
          class="digital-field modal-standard-field"
          [class.digital-field--invalid]="shouldShowDigitalAdmissionFieldError('cpf') && !isDigitalAdmissionCpfValid()">
          <mat-label>CPF</mat-label>
          <input
            matInput
            type="text"
            inputmode="numeric"
            maxlength="14"
            [(ngModel)]="digitalAdmissionForm.cpf"
            (ngModelChange)="onDigitalAdmissionCpfInput($event)"
            (blur)="markDigitalAdmissionFieldTouched('cpf')"
            [disabled]="digitalAdmissionFeedbackState === 'loading'"
          >
          <mat-error *ngIf="shouldShowDigitalAdmissionFieldError('cpf') && !isDigitalAdmissionCpfValid()">
            Informe um CPF válido.
          </mat-error>
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          class="digital-field modal-standard-field"
          [class.digital-field--invalid]="shouldShowDigitalAdmissionFieldError('full_name') && !isDigitalAdmissionFullNameValid()">
          <mat-label>Nome completo</mat-label>
          <input
            matInput
            type="text"
            [(ngModel)]="digitalAdmissionForm.full_name"
            (blur)="markDigitalAdmissionFieldTouched('full_name')"
            [disabled]="digitalAdmissionFeedbackState === 'loading'"
          >
          <mat-error *ngIf="shouldShowDigitalAdmissionFieldError('full_name') && !isDigitalAdmissionFullNameValid()">
            Preencha o nome completo.
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="digital-field modal-standard-field digital-date-field">
          <mat-label>Data de nascimento</mat-label>
          <input
            matInput
            [matDatepicker]="birthDatePicker"
            [(ngModel)]="digitalAdmissionForm.birth_date"
            [ngModelOptions]="{ updateOn: 'blur' }"
            inputmode="numeric"
            maxlength="10"
            (input)="onDigitalAdmissionDateInput($event)"
            (blur)="onDigitalAdmissionDateBlur('birth_date', $event)"
            (dateChange)="onDigitalAdmissionDateChange('birth_date', $event)"
            [disabled]="digitalAdmissionFeedbackState === 'loading'"
          >
          <mat-datepicker-toggle matSuffix [for]="birthDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #birthDatePicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          class="digital-field modal-standard-field digital-date-field"
          [class.digital-field--invalid]="shouldShowDigitalAdmissionFieldError('hired_at') && !isDigitalAdmissionHiredDateValid()">
          <mat-label>Data de admissão</mat-label>
          <input
            matInput
            [matDatepicker]="hiredAtDatePicker"
            [min]="digitalAdmissionMinHiredDateValue"
            [(ngModel)]="digitalAdmissionForm.hired_at"
            [ngModelOptions]="{ updateOn: 'blur' }"
            inputmode="numeric"
            maxlength="10"
            (input)="onDigitalAdmissionDateInput($event)"
            (blur)="onDigitalAdmissionDateBlur('hired_at', $event); markDigitalAdmissionFieldTouched('hired_at')"
            (dateChange)="onDigitalAdmissionDateChange('hired_at', $event); markDigitalAdmissionFieldTouched('hired_at')"
            [disabled]="digitalAdmissionFeedbackState === 'loading'"
          >
          <mat-datepicker-toggle matSuffix [for]="hiredAtDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #hiredAtDatePicker></mat-datepicker>
          <mat-error *ngIf="shouldShowDigitalAdmissionFieldError('hired_at') && !isDigitalAdmissionHiredDateValid()">
            A data de admissão deve ser hoje ou uma data futura.
          </mat-error>
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          class="digital-field modal-standard-field"
          [class.digital-field--invalid]="shouldShowDigitalAdmissionFieldError('personal_email') && !isDigitalAdmissionEmailValid()">
          <mat-label>E-mail pessoal</mat-label>
          <input
            matInput
            type="email"
            [(ngModel)]="digitalAdmissionForm.personal_email"
            (blur)="markDigitalAdmissionFieldTouched('personal_email')"
            [disabled]="digitalAdmissionFeedbackState === 'loading'"
          >
          <mat-error *ngIf="shouldShowDigitalAdmissionFieldError('personal_email') && !isDigitalAdmissionEmailValid()">
            Informe um e-mail válido.
          </mat-error>
        </mat-form-field>
        </div>
      </section>
    </div>
  </div>

  <div class="modal-actions">
    <button class="btn ghost digital-btn--intelligence" type="button" (click)="prefillDigitalAdmission()" [disabled]="digitalAdmissionFeedbackState === 'loading'">
      <mat-icon>auto_awesome</mat-icon>
      Preencher automaticamente
    </button>
    <button class="btn ghost" type="button" (click)="closeDigitalAdmissionModal()" [disabled]="digitalAdmissionFeedbackState === 'loading'">Cancelar</button>
    <button
      class="btn primary"
      type="button"
      (click)="saveDigitalAdmission()"
      [disabled]="digitalAdmissionFeedbackState === 'loading' || !isDigitalAdmissionFormValid()"
    >
      {{ digitalAdmissionFeedbackState === 'loading' ? 'Enviando...' : 'Enviar link' }}
    </button>
  </div>
</section>

<div class="modal-backdrop" *ngIf="showAlertModal" (click)="closeAlertModal()"></div>
<section class="modal wide digital-admission-modal alert-rule-modal" *ngIf="showAlertModal">
  <header class="digital-admission-modal__header">
    <div class="digital-admission-modal__title-wrap">
      <span class="digital-admission-modal__eyebrow">ControlDP · Alertas Inteligentes</span>
      <h2>{{ editingAlertRuleId ? 'Editar alerta' : 'Novo alerta' }}</h2>
      <p>Crie regras para sinalizar possíveis riscos no processo de admissão digital.</p>
    </div>
    <button type="button" class="close" (click)="closeAlertModal()">&times;</button>
  </header>

  <div class="modal-body">
    <div class="alert-rule-config-layout">
      <div class="digital-admission-form-surface alert-rule-config-surface">
      <div class="digital-admission-form-surface__head">
        <strong>Configuração do alerta</strong>
        <small>Defina referência, unidade de validação e condição de disparo.</small>
      </div>
      <div class="form-grid digital-admission-grid">
        <mat-form-field
          appearance="outline"
          class="digital-field modal-standard-field"
          [class.digital-field--invalid]="alertRuleSubmitAttempted && !alertRuleForm.alert_name?.trim()">
          <mat-label>Nome do alerta</mat-label>
          <input matInput type="text" maxlength="160" [(ngModel)]="alertRuleForm.alert_name" [disabled]="alertRuleSaving">
          <mat-error *ngIf="alertRuleSubmitAttempted && !alertRuleForm.alert_name?.trim()">Informe o nome do alerta.</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="digital-field modal-standard-field">
          <mat-label>Tipo do alerta</mat-label>
          <mat-select [(ngModel)]="alertRuleForm.location_type" (selectionChange)="onAlertLocationTypeChange()" [disabled]="alertRuleSaving">
            <mat-option *ngFor="let option of alertLocationTypeOptions" [value]="option.value">
              {{ option.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          class="digital-field modal-standard-field"
          [class.digital-field--invalid]="alertRuleSubmitAttempted && !alertRuleForm.location_value?.trim()">
          <mat-label>CEP ou rua de referência</mat-label>
          <input
            matInput
            type="text"
            [maxlength]="alertRuleForm.location_type === 'CEP' ? 9 : 200"
            [attr.inputmode]="alertRuleForm.location_type === 'CEP' ? 'numeric' : 'text'"
            [(ngModel)]="alertRuleForm.location_value"
            (input)="onAlertLocationInput($event)"
            (blur)="onAlertLocationBlur()"
            [disabled]="alertRuleSaving">
          <mat-error *ngIf="alertRuleSubmitAttempted && !alertRuleForm.location_value?.trim()">Informe CEP ou endereço.</mat-error>
          <mat-error *ngIf="alertRuleSubmitAttempted && isAlertCepInvalid()">
            Informe um CEP válido (8 dígitos).
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="digital-field modal-standard-field">
          <mat-label>Unidade de validação</mat-label>
          <mat-select [(ngModel)]="alertRuleForm.validation_unit" (selectionChange)="onAlertValidationUnitChange()" [disabled]="alertRuleSaving">
            <mat-option *ngFor="let option of alertValidationUnitOptions" [value]="option.value">
              {{ option.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="digital-field modal-standard-field" *ngIf="alertRuleForm.validation_unit === 'TRAVEL_TIME'">
          <mat-label>Modo de deslocamento</mat-label>
          <mat-select [(ngModel)]="alertRuleForm.travel_mode" [disabled]="alertRuleSaving">
            <mat-option *ngFor="let option of alertTravelModeOptions" [value]="option.value">
              {{ option.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="digital-field modal-standard-field">
          <mat-label>Variável de verificação</mat-label>
          <mat-select [(ngModel)]="alertRuleForm.condition_operator" (selectionChange)="onAlertConditionOperatorChange()" [disabled]="alertRuleSaving">
            <mat-option *ngFor="let option of alertConditionOptions" [value]="option.value">
              {{ option.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          class="digital-field modal-standard-field"
          [class.digital-field--invalid]="alertRuleSubmitAttempted && !(alertRuleForm.condition_value_min >= 0)">
          <mat-label>Valor mínimo</mat-label>
          <input matInput type="number" min="0" step="0.1" [(ngModel)]="alertRuleForm.condition_value_min" [disabled]="alertRuleSaving">
          <mat-error *ngIf="alertRuleSubmitAttempted && !(alertRuleForm.condition_value_min >= 0)">Informe um valor válido.</mat-error>
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          class="digital-field modal-standard-field"
          *ngIf="alertRuleForm.condition_operator === 'BETWEEN'"
          [class.digital-field--invalid]="alertRuleSubmitAttempted && !(alertRuleForm.condition_value_max >= alertRuleForm.condition_value_min)">
          <mat-label>Valor máximo</mat-label>
          <input matInput type="number" min="0" step="0.1" [(ngModel)]="alertRuleForm.condition_value_max" [disabled]="alertRuleSaving">
          <mat-error *ngIf="alertRuleSubmitAttempted && !(alertRuleForm.condition_value_max >= alertRuleForm.condition_value_min)">Valor máximo deve ser maior ou igual ao mínimo.</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="digital-field modal-standard-field">
          <mat-label>Ação</mat-label>
          <mat-select [(ngModel)]="alertRuleForm.action_type" [disabled]="alertRuleSaving">
            <mat-option value="GENERATE_ALERT">Gerar alerta</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      </div>

      <div class="alert-rule-map alert-rule-map--side" *ngIf="alertRuleForm.location_type === 'CEP' && alertRuleMapEmbedUrl">
        <strong>Mapa de referência dos CEPs</strong>
        <small>Digite um CEP válido para abrir o mapa interativo (zoom e navegação).</small>
        <div class="alert-rule-map__frame" [class.is-loading]="alertRuleMapLoading">
          <iframe
            *ngIf="alertRuleMapEmbedUrl"
            [src]="alertRuleMapEmbedUrl"
            title="Mapa de referência dos alertas CEP"
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
            (load)="onAlertRuleMapImageLoaded()"
            (error)="onAlertRuleMapImageError()"
          ></iframe>
        </div>
      </div>
    </div>

    <div class="alert-rule-existing" *ngIf="alertRules.length">
      <strong>Alertas cadastrados</strong>
      <div class="alert-rule-existing__list">
        <article class="alert-rule-existing__item" *ngFor="let alert of alertRules">
          <div class="alert-rule-existing__item-head">
            <h4>{{ alert.alert_name }}</h4>
            <div class="alert-rule-existing__item-actions">
              <mat-slide-toggle
                class="alert-rule-existing__toggle"
                color="primary"
                [checked]="isAlertRuleActive(alert)"
                [disabled]="alertRuleSaving || alertRuleTogglingId === alert.id"
                (change)="toggleAlertRuleActive(alert, $event.checked)">
                {{ isAlertRuleActive(alert) ? 'Ativa' : 'Inativa' }}
              </mat-slide-toggle>
              <button
                type="button"
                class="btn ghost small alert-rule-existing__edit-btn"
                (click)="editAlertRule(alert)"
                [disabled]="alertRuleSaving || alertRuleTogglingId === alert.id">
                Editar regra
              </button>
            </div>
          </div>
          <div class="alert-rule-existing__item-lines">
            <p><span>Referência</span><strong>{{ alertRuleLocationLabel(alert) }}</strong></p>
            <p><span>Validação</span><strong>{{ alertRuleValidationLabel(alert) }}</strong></p>
            <p><span>Condição</span><strong>{{ alertRuleConditionLabel(alert) }}</strong></p>
            <p><span>Ação</span><strong>{{ alertRuleActionLabel(alert) }}</strong></p>
          </div>
          <small *ngIf="alertRuleMetaLabel(alert)">{{ alertRuleMetaLabel(alert) }}</small>
        </article>
      </div>
    </div>
  </div>

  <div class="modal-actions digital-admission-actions">
    <span class="alert-rule-modal__error" *ngIf="alertRuleError">{{ alertRuleError }}</span>
    <button
      class="btn ghost digital-btn digital-btn--ghost"
      type="button"
      *ngIf="editingAlertRuleId"
      (click)="openAlertModal()"
      [disabled]="alertRuleSaving">
      Cancelar edição
    </button>
    <button class="btn ghost digital-btn digital-btn--ghost" type="button" (click)="closeAlertModal()" [disabled]="alertRuleSaving">Cancelar</button>
    <button
      class="btn primary digital-btn digital-btn--primary"
      type="button"
      (click)="saveAlertRule()"
      [disabled]="alertRuleSaving || !isAlertRuleFormValid()"
    >
      {{ alertRuleSubmitLabel }}
    </button>
  </div>
</section>

<div class="modal-backdrop" *ngIf="showRoleModal" (click)="closeModals()"></div>
<section class="modal modal-card wide cad-role-modal" *ngIf="showRoleModal" (click)="$event.stopPropagation()">
  <header>
    <div>
      <h2>{{ editingRole ? 'Editar cargo' : 'Novo cargo' }}</h2>
      <small>Cadastre e mantenha os cargos disponíveis no ControlDP.</small>
    </div>
    <button type="button" class="close" (click)="closeModals()">&times;</button>
  </header>
  <div class="cp-modal-body">
    <div class="cp-tabs role-tabs">
      <button
        mat-stroked-button
        type="button"
        *ngFor="let tab of roleModalTabs"
        [class.active]="roleModalTab === tab.value"
        (click)="setRoleModalTab(tab.value)">
        <mat-icon>{{ tab.icon }}</mat-icon>
        {{ tab.label }}
      </button>
    </div>

    <div class="cp-modal-scroll">
      <section class="panel" *ngIf="roleModalTab === 'cadastro'">
        <div class="cp-form-row role-form-grid">
          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Nome do cargo</mat-label>
            <input matInput type="text" [(ngModel)]="roleForm.name">
          </mat-form-field>
          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Salário base</mat-label>
            <input matInput type="number" step="0.01" [(ngModel)]="roleForm.base_salary">
          </mat-form-field>
        </div>
      </section>

      <section class="panel role-list-panel" *ngIf="roleModalTab === 'cargos'">
        <header>
          <h4>Cargos cadastrados</h4>
          <small>Total: {{ roles.length }}</small>
        </header>
        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>Nome</th>
                <th>Salário</th>
                <th>Ação</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let role of roles">
                <td>{{ role.name }}</td>
                <td>{{ role.base_salary || '—' }}</td>
                <td class="actions">
                  <button class="btn ghost small" type="button" (click)="editRole(role)">Editar</button>
                </td>
              </tr>
              <tr *ngIf="!roles.length">
                <td colspan="3" class="empty">Nenhum cargo cadastrado.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>
  </div>

  <div class="modal-actions">
    <button class="btn ghost" type="button" (click)="closeModals()">Cancelar</button>
    <button class="btn primary" type="button" *ngIf="roleModalTab === 'cadastro'" (click)="saveRole()">
      {{ editingRole ? 'Salvar alterações' : 'Salvar cargo' }}
    </button>
  </div>
</section>

<div class="modal-backdrop" *ngIf="showImportModal" (click)="closeModals()"></div>
<section class="modal wide" *ngIf="showImportModal">
  <header>
    <div>
      <h2>Importar base</h2>
      <p>Selecione a planilha e valide os dados antes de importar.</p>
    </div>
    <button type="button" class="close" (click)="closeModals()">&times;</button>
  </header>
  <div class="import-uploader">
    <input type="file" accept=".csv,.xlsx" (change)="handleImportFile($event)">
    <small>{{ importFileName || 'Nenhum arquivo selecionado' }}</small>
  </div>
  <div class="import-preview" *ngIf="importPreviewRows.length">
    <h4>Preview da planilha</h4>
    <div class="table-wrapper">
      <table>
        <thead>
          <tr>
            <th *ngFor="let header of importHeaders">{{ header }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of importPreviewRows">
            <td *ngFor="let header of importHeaders">{{ row[header] }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="import-feedback" *ngIf="importFeedback">
    <strong>{{ importFeedback }}</strong>
    <div class="error-list" *ngIf="importErrorRows.length">
      <p>Linhas com erro:</p>
      <ul>
        <li *ngFor="let row of importErrorRows.slice(0, 10)">
          Linha {{ row.row_index }} · {{ row.__error || 'Erro de validação' }}
        </li>
      </ul>
      <small *ngIf="importErrorRows.length > 10">Mostrando 10 primeiros erros.</small>
    </div>
  </div>
  <div class="modal-actions">
    <button class="btn ghost" type="button" (click)="closeModals()">Cancelar</button>
    <button class="btn primary" type="button" [disabled]="importLoading || !importPreviewRows.length" (click)="confirmImport()">
      {{ importLoading ? 'Importando...' : 'Confirmar importação' }}
    </button>
  </div>
</section>
